<style scoped>
.transportWrap >>> .el-input__inner {
  text-align: right !important;
}
</style>
<template>
  <div>
    <div style="position: absolute;z-index:2;top: 81px;left: 0;width: 100%;background-color: rgba(245, 245, 245, 0.1);" v-if="topMessageList.length">
      <scroll-message-row :list="topMessageList"/>
    </div>
    <!-- style="height:calc(90%);position: relative" -->
    <div style="height: 100%; background: #F9F9F9">
      <div :class="NodisType ? 'index_wrap' : 'notBg'" style="width: 100%;height: calc(100vh - 70px); position: relative; z-index: 1">
        <el-carousel height="calc(100vh - 70px)" loop>
          <template v-if="homePageBanner.length">
            <el-carousel-item v-for="item in homePageBanner" :key="item.id" class="banner-item">
              <img data-v-2e461e0c="" :src="item.logo" style="width: 100%" class="home-banner-slide__image" @click="bannerJump(item)">
            </el-carousel-item>
          </template>
          <template v-else>
            <el-carousel-item>
              <img data-v-2e461e0c="" :src="ossPath + '/pages/home/banner4.jpg'" style="width: 100%;" class="home-banner-slide__image">
            </el-carousel-item>
          </template>
        </el-carousel>
        <!-- 首页头部 物流产品 查询-->
        <div style="width: 1200px;position: relative;margin: -70px auto 0;">
          <div class="query-change-wrap" style="position: absolute; top: -50px">
            <div class="query-item" :class="{isCurrent: queryType === 1}" @click="queryType = 1">查运价</div>
            <div class="query-item" :class="{isCurrent: queryType === 2}" @click="inquiryShow">发布询盘</div>
          </div>
          <div>
            <div v-show="queryType === 1">
              <home-product-tabs class="home-transport-tabs" @change="productTabChange"></home-product-tabs>
              <div class="common-box all-padding common-box-showdown join-group-form-box" style="z-index: 9;width: 1200px;">
                <home-query-logistics-products
                  :default-product-type="productTabCurrent"
                  btn-text="查询"
                />
              </div>
            </div>
            <div v-show="queryType === 2">
              <div style="position: relative; z-index: 99;">
                <div>
                  <ul class="inquiry-tab" style="">
                    <li style="" :class="{isactive: inquiryBusinessType === 1}" @click="inquiryBusinessType = 1">
                      <img style="width: 17px; height: 17px; vertical-align: -2px" :src="ossPath + (inquiryBusinessType === 1 ? '/pages/home/portToDoor1_active.png' : '/pages/home/portToDoor1.png')" alt="">
                      <span>整柜到门</span>
                    </li>
                    <li style="" :class="{isactive: inquiryBusinessType === 2}" @click="inquiryBusinessType = 2">
                      <img style="width: 17px; height: 17px; vertical-align: -2px" :src="ossPath + (inquiryBusinessType === 2 ? '/pages/home/icon_FBA_active.png' : '/pages/home/icon_FBA1.png')" alt="">
                      <span>FBA</span>
                    </li>
                    <li style="" :class="{isactive: inquiryBusinessType === 3}" @click="inquiryBusinessType = 3">
                      <img style="width: 17px; height: 17px; vertical-align: -2px" :src="ossPath +(inquiryBusinessType === 3 ? '/pages/home/seaBulk_active.png' : '/pages/home/seaBulk.png')" alt="">
                      <span>海运拼箱</span>
                    </li>
                    <li style="" :class="{isactive: inquiryBusinessType === 4}" @click="inquiryBusinessType = 4">
                      <img style="width: 17px; height: 17px; vertical-align: -2px" :src="ossPath +(inquiryBusinessType === 4 ? '/pages/home/icon_air_active.png' : '/pages/home/icon_air.png')" alt="">
                      <span>国际空运</span>
                    </li>
                    <li style="" :class="{isactive: inquiryBusinessType === 5}" @click="inquiryBusinessType = 5">
                      <img style="width: 17px; height: 17px; vertical-align: -2px" :src="ossPath +(inquiryBusinessType === 5 ? '/pages/home/icon_land_active.png' : '/pages/home/icon_land.png')" alt="">
                      <span>陆运</span>
                    </li>
                  </ul>
                </div>
                <div class="common-box all-padding common-box-showdown join-group-form-box" style="width: 1200px;">
                  <inquiryQueryHomeBar v-show="inquiryBusinessType === 1" :inquiryBusinessType="inquiryBusinessType" :inquiryType="2"/>
                  <div><homeInquiryFba v-if="inquiryBusinessType === 2" :inquiryBusinessType="inquiryBusinessType"  /></div>
                  <div><homeInquiryNotfba v-if="inquiryBusinessType === 3" :inquiryBusinessType="inquiryBusinessType"  /></div>
                  <div><homeInquiryNotfba v-if="inquiryBusinessType === 4" :inquiryBusinessType="inquiryBusinessType"  /></div>
                  <div><homeInquiryNotfba v-if="inquiryBusinessType === 5" :inquiryBusinessType="inquiryBusinessType"  /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<img data-v-2e461e0c="" :src="ossPath + '/pages/home/banner4.jpg'" style="width: 100%" class="home-banner-slide__image">-->
        <!-- <logoFloat ref="appli" :countryData="countryData"></logoFloat> -->
      </div>

      <!-- <div v-show="activeType == 2">
        <BillText></BillText>
      </div> -->
      <!-- <loginType ref="child"></loginType> -->


      <el-drawer
        :title="`${currentPriceComparisonTabItem ? currentPriceComparisonTabItem.name : ''}详情`"
        :visible.sync="visiblePriceComparison"
        lock-scroll
        :modal="false"
        ppend-to-body
        direction="rtl"
        custom-class="home-price-comparison-drawer"
        size="800px">
        <div style="padding: 0 12px;overflow: auto;box-sizing: border-box;height: 100%;">
          <div style="margin-bottom: 20px;display: flex;justify-content: space-around">
            <span>起运地：{{ compareBaseInfo.cityName || '-' }}</span>
            <span>目的国：{{ compareBaseInfo.toCountryName || '-' }}</span>
            <span>目的地：{{ compareBaseInfo.toCitiNames || '-' }}</span>
            <span>运输方案：{{ compareBaseInfo.transportSchemeName || '-' }}</span>
          </div>
          <el-table :data="priceComparisonList" :header-cell-style="{ background: '#fff0f3', color: '#999' }" height="98%" v-loading="priceComparisonListLoading">
            <el-table-column property="carrierAbbrName" label="专线名称" min-width="150" align="center"></el-table-column>
            <el-table-column property="priceDesc" label="价格" width="180" align="center">
              <template slot-scope="scope">
                <!--{{scope.row.currency||""}}
                <span style="color: #ff0000;">{{  scope.row.price||0 }}</span>/
                {{scope.row.dateType ? "自然日" : "工作日" }}-->
                <el-tooltip placement="bottom" effect="dark" popper-class="head-propper-tips" v-if="scope.row.isSegment">
                  <div slot="content" style="width: 200px; font-size: 14px; line-height: 16px;">
                    该报价为两段报价，显示的是到海外仓的价格，海外仓到目的地的派送价格请到方案详情查看。
                  </div>
                  <img style="vertical-align: text-bottom;width: 40px;height: 17px" :src="ossPath + '/pages/home/head_line.png'" alt="">
                </el-tooltip>
                {{ scope.row.priceDesc }}
              </template>
            </el-table-column>
            <el-table-column property="aging" label="参考时效" width="180" align="center"></el-table-column>
            <el-table-column property="address" label="报价链接" width="220" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" type="primary" @click="lookPriceComparisonPlanDetails(scope.row)">查看方案详情</el-link>
                <el-button type="primary" style="margin-left: 12px;" v-if="scope.row.isAllowCreateOrder" @click="priceComparisonPlaceOrder(scope.row)">立即下单</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-drawer>
      <!-- 热门线路 -->
      <!--<div style="clear: both"></div>
      <div class="search-bottom-box" :style="`background-image:url(${ossPath + '/pages/home/country/bg.png'})`" v-show="!topType && hotStyleLIst.length">
        <div class="hot-join-group page-size-container">
          <div style="text-align: center; padding-top: 30px; margin-bottom: 20px">
            <img :src="ossPath + '/pages/home/popular-line.png'" alt="">
          </div>
          <div class="hot-join-group__header"  >
            &lt;!&ndash; <div class="title">热门线路</div> &ndash;&gt;
            <div class="flex-1"></div>
            &lt;!&ndash; <router-link class="next" :to="{path:'/placeOrder/placeindexInfo/queryPrice'}"> &ndash;&gt;
            &lt;!&ndash; <span class="">更多线路</span> &ndash;&gt;
            &lt;!&ndash; <img class="icon" :src="images.next"> &ndash;&gt;
            &lt;!&ndash; <span class="">查看当前<label style="color: #FF4D01">{{num ? `${num}+` : ''}}</label>可跟单</span> &ndash;&gt;
            &lt;!&ndash; <i class="el-icon-caret-right" style="color: #FF4D01"></i> &ndash;&gt;
            &lt;!&ndash; </router-link> &ndash;&gt;
          </div>
          <div class="hot-join-group__list" >
            &lt;!&ndash; <div class="Hot_wrap_x" v-if="hotStyleLIst = [{fromCityInfo: {}}]"> &ndash;&gt;
            <div class="Hot_wrap_x">
              <el-row :gutter="20">
                <el-col  :span="8" v-for="(item, index) in hotStyleLIst" :key="index">

                  <el-card
                    class="card_Hover"
                    shadow="hover"
                    style="
                    border-radius: 20px;
                    height: 236px;
                    padding: 0 0 30px 0;
                    margin-bottom: 15px;
                    position: relative;
                  "
                  >
                    <div class="hot-line-label" v-if="item.label1">
                      <div class="hot-line-label&#45;&#45;item" v-for="(item,index) in [item.label1]" :key="index">{{ item }}</div>
                    </div>
                    <div class="hotItem" >



                        <div
                          class="hot-info"
                          style="
                          margin-top: 16px;
                          font-size: 16px;
                          font-weight: 500;

                        "
                        >
                        <div style="position: absolute; top: 0px; left: 255px;"
                             :class="{
                                'air-bg': item.transportTypeName === '空运',
                                'ship-bg': item.transportTypeName === '海运',
                                'pickup-bg': item.transportTypeName === '陆运'
                             }"
                        >
                        </div>


                        <span style="font-size: 18px; font-weight: bold">{{ item.productName }}</span>
                          &lt;!&ndash; 收藏icon &ndash;&gt;
                          <span
                            style="float: right;z-index: 1"
                            :class="
                            item.concernSign
                              ? 'icon_collect_pre'
                              : 'icon_collect'
                          "
                            :style="{
                            color: item.concernSign ? '#FFBF4D' : '',
                          }"
                            @click.stop="followItemHot(item)"
                          ></span>
                        </div>

                      <div
                        class="card_x"
                        style="
                        margin-top: 20px;
                        font-size: 14px;
                        color: #333333;
                      "
                      >
                       &lt;!&ndash;  <div
                          class="card_text"
                          style="
                          display: flex;
                          align-items: center;
                        "
                        >
                          <div style="min-width: 120px">
                            <span style="color: #999999">起运地：</span>
                            <span
                              style="font-size: 14px; font-weight: bold"
                            >{{ item.fromCityInfo.namec }}</span>
                          </div>
                          <div
                            style="margin-left: 46px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                          "
                          >
                            <span style="color: #bfbfbf">目的国：</span>
                            <span
                              style="font-size: 14px; font-weight: bold"
                            >{{ item.countryNamec }}</span>
                          </div>
                        </div>
                        <div
                          class="card_text"
                          style="display: flex;
                          align-items: center;
                          height: 70px;
                        "
                        >
                          <div style="min-width: 120px">
                            <span style="color: #999999">目的仓库：</span>
                            <span
                              style="font-size: 14px; font-weight: bold"
                            >{{ item.toWarehouseInfo.namec }}</span>
                          </div>
                          <div
                            style="margin-left: 46px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                          "
                          >
                            <span style="color: #bfbfbf">可接货物：</span>
                            <span
                              style="font-size: 14px; font-weight: bold"
                            >{{ item.goodsTypeNames }}</span>
                          </div>
                        </div> &ndash;&gt;
                        <div style="display: flex; color: #999999;  font-size: 15px; line-height: 30px;">
                            <span v-if="!item.isSegment"  style="flex: 1;">
                              {{ item.agingIsShow ? "整体时效：" : "提取时效："}}
                            </span>
                            <span v-else  style="flex: 1;">
                              整体时效：
                            </span>
                            <span
                            style="flex: 3;"
                            >
                           &lt;!&ndash;  <el-tooltip
                              :content="agingType[item.agingType]"
                              placement="top-start"
                            >
                              <i class="el-icon-question" style="color:#e6a23c;"></i>
                            </el-tooltip> &ndash;&gt;
                            {{ item.aging ||"-"}}
                          </span>
                          </div>
                        <div style="display: flex; color: #999999;  font-size: 15px; line-height: 30px;">
                        <span  style=" flex: 1;" >起运地：</span>
                        <span style="flex: 3;">{{ item.fromCityInfo.namec }}</span>
                      </div>
                      <div style="display: flex; color: #999999;  font-size: 15px; line-height: 30px;">
                        <span  style=" flex: 1;" >目的地：</span>
                        <span style="flex: 3;">{{ item.countryNamec }}{{ item.toWarehouseInfo ? ` (${item.toWarehouseInfo.namec})` || '' : '' }}</span>
                      </div>
                      <div style="display: flex; color: #999999;  font-size: 15px; line-height: 30px;">
                        <span  style=" flex: 1;" >可接货物：</span>
                        <span style="flex: 3;">{{ item.goodsTypeNames }}</span>
                      </div>
                        <div class="LR_center" >
                          <el-tooltip placement="bottom" effect="dark" popper-class="head-propper-tips" v-if="item.isSegment">
                            <div slot="content" style="width: 200px; font-size: 14px; line-height: 16px;">
                              该报价为两段报价，显示的是到海外仓的价格，海外仓到目的地的派送价格请到方案详情查看。
                            </div>
                            <img style="
                            position: absolute;
                            left: 30px;
                            top: 220px;width: 43px" :src="ossPath + '/pages/home/head_line.png'" alt="">
                          </el-tooltip>

                          <div
                            style="
                            font-size: 18px;
                            color: #FF4D01;
                            font-weight: bold;
                            position: absolute;
                            left: 75px;
                            top: 215px;
                          "
                          >
                            <price-blurring
                              :price-display-type="item.priceDisplayType"
                              :currency="item.currency"
                              :price="item.lowestPrice ? item.lowestPrice : '单询'"
                              :unit="item.chargeType"
                              inline
                              class="hot-line-item"
                            />
                          </div>
                          <div>
                            &lt;!&ndash; <div
                              id="setHotcity"
                              @click="setHotcity(item, false,'热门线路')" &ndash;&gt;
                            <div
                              id="setHotcity"
                              @click="getUsertypeRap(item)"
                              style="
                               font-size: 18px;
                            color: white;
                            font-weight: bold;
                            position: absolute;
                            left: 260px;
                            top: 220px;
                            cursor: pointer;"

                            >
                            立即下单
                           &lt;!&ndash;  <span
                              style="
                                font-weight: bold;
                                font-size: 18px;
                                font-family: PingFang SC;
                                font-weight: bold;
                              "
                            ></span> &ndash;&gt;
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
          &lt;!&ndash; <div class="join-scroll-message" v-if="messageList.length">
            <scroll-message :data="messageList"
                            height="30px"></scroll-message>
          </div> &ndash;&gt;
          &lt;!&ndash; <el-tabs v-model="activeName" @tab-click="handleClickHot">
            <el-tab-pane name="first">
              <span slot="label">
                <div class="label-1">
                  <img class="imgs" src="@/assets/hot_fba.png" alt />
                  <span style="font-size: 24px; color: black; font-weight: bold">FBA</span>
                </div>
              </span>
              <div>
                <div class="Hot_wrap_x">
                  <el-row :gutter="20">
                    <el-col :span="8" v-for="(item, index) in hotStyleLIst" :key="index">
                      <el-card
                        class="card_Hover"
                        shadow="hover"
                        style="
                          border-radius: 20px;
                          height: 236px;
                          background: #f5f5f5;
                          padding: 0 0 30px 0;
                        "
                      >
                        <div class="hotItem">
                          <div
                            class="card_s"
                            style="
                              border-bottom: 2px dashed #bfbfbf;
                              padding-bottom: 20px;
                            "
                          >
                            <div style="font-size: 18px; font-weight: bold">{{ item.productName }}</div>
                            <div
                              class="hot-info"
                              style="
                                margin-top: 16px;
                                font-size: 16px;
                                font-weight: 500;
                                color: #FF4D01;
                              "
                            >
                              <span
                                v-if="item.aging"
                                style="
                                  height: 20px;
                                  display: block;
                                  height: 14px;
                                  font-size: 14px;
                                  font-family: Source Han Sans CN;
                                  font-weight: 500;
                                  color: #FF4D01;
                                "
                              >
                                {{ item.aging ? "时效：" : "时效：/"
                                }}{{ item.aging }}
                              </span>
                              <span v-else></span>
                              <span
                                style="float: right"
                                :class="
                                  item.concernSign
                                    ? 'icon_collect_pre'
                                    : 'icon_collect'
                                "
                                :style="{
                                  color: item.concernSign ? '#FFBF4D' : '',
                                }"
                                @click.stop="followItemHot(item)"
                              ></span>
                            </div>
                          </div>
                          <div
                            class="card_x"
                            style="
                              margin-top: 20px;
                              font-size: 14px;
                              color: #333333;
                            "
                          >
                            <div
                              class="card_text"
                              style="
                                display: flex;
                                align-items: center;
                                height: 70px;
                              "
                            >
                              <div style="min-width: 120px">
                                <span style="color: #999999">起运地：</span>
                                <span
                                  style="font-size: 14px; font-weight: bold"
                                >{{ item.fromCityInfo.namec }}</span>
                              </div>
                              <div
                                style="
                                  margin-left: 46px;
                                  text-overflow: ellipsis;
                                  overflow: hidden;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 3;
                                  -webkit-box-orient: vertical;
                                "
                              >
                                <span style="color: #bfbfbf">可接货物：</span>
                                <span
                                  style="font-size: 14px; font-weight: bold"
                                >{{ item.goodsTypeNames }}</span>
                              </div>
                            </div>
                            <div class="LR_center">
                              <div
                                style="
                                  font-size: 18px;
                                  color: #FF4D01;
                                  font-weight: bold;
                                "
                              >
                                {{ item.currency }}
                                <span style="font-size: 30px">
                                  {{
                                  item.lowestPrice
                                  }}
                                </span>
                                <span style="font-size: 16px">/{{ item.chargeType }}起</span>
                              </div>
                              <div>
                                <div
                                  id="setHotcity"
                                  @click="setHotcity(item, false,'热门线路')"
                                  class="popularBtn count_center"
                                >
                                  <span
                                    style="
                                      font-weight: bold;
                                      font-size: 18px;
                                      font-family: PingFang SC;
                                      font-weight: bold;
                                    "
                                  >立即下单</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs> &ndash;&gt;
        </div>
      </div>-->

      <!-- 热门比价 -->
      <div style="clear: both"></div>
      <div :style="`background-image:url(${ossPath + '/pages/home/hot_compare_bg.png'})`" style="max-height: 1019px;margin-top: 0;overflow:hidden;padding-top: 148px;box-sizing: border-box">
        <!--   全球比价   -->
        <template v-if="isOpen && globalPriceComparisonTabs.length">
          <div style="clear: both"></div>
          <global-price-comparison
            class="home-price-comparison page-size-container"
            :list="globalPriceComparisonTabs"
            @clickItem="clickPriceComparisonTabItem"
            :loading="priceComparisonTabsLoading"
          />
        </template>
        <home-hot-price-compare></home-hot-price-compare>
      </div>

      <!-- 会员专区 -->
      <div style="clear: both"></div>
      <div class="member-zone">
        <div class="Hotmemberzone" style="margin-top: 31px;padding-bottom: 20px;">
          <div style="padding-top: 30px; width: 1200px; margin: 0 auto;">
            <home-hot-member-zone></home-hot-member-zone>
          </div>
        </div>
      </div>

      <!-- 金融专区 -->
      <!-- <div style="clear: both"></div>
      <div class="member-zone">
        <div class="Hotmemberzone">
          <img :src="ossPath + '/pages/home/jinrong_banner3.png?v=1'" alt="" style="width: 100%;"/>
          <div class="clickable-area" style="bottom: calc(28%); left: calc(46%);"  @click="gotoJinrong()"></div>
        </div>
      </div> -->
      
      <!-- 云仓推广 -->
      <!-- <div class="cloud_warehouse">
        <div style="text-align: center;padding-top: 36px;">
          <img :src="ossPath + '/pages/home/yun_warehouse/title-g.png'" alt="" />
        </div>
        <div style="width: 1200px;margin: 0 auto;">
          <div class="cloud-ware-tabs">
            <div class="cloud-ware-tabs__item" :class="{isActive: currentCloudWareType === 1}" @click="currentCloudWareType = 1">国内云仓</div>
            <div class="cloud-ware-tabs__item" :class="{isActive: currentCloudWareType === 2}" @click="currentCloudWareType = 2" v-if="false">海外云仓</div>
          </div>
          <div v-show="currentCloudWareType === 1">
            <div class="apply">
              <div>
                共享仓免费用&nbsp;&nbsp;
                全球FBA专线一站选
              </div>
              // 不要的
              <!-<div class="apply_btn" @click="applyShareWarehouse">申请共享仓</div>->
            </div>
            <div class="advantage" :style="`background: url(${ossPath}/pages/home/cloud-ware-ad-bg.png) no-repeat`">
              <div v-for="(item, index) in yunWarehouseAdvantage" :key="index" style="display: flex;" :style="item.style">
                <div style="width: 15px;height: 15px;border-radius: 50%;background-color: #422D1E;display: flex;align-items: center;margin-right: 3px;margin-top: 4px;">
                  <i class="el-icon-check" style="color: #FFCBAF;line-height: 1;font-weight: bold;font-size: 14px;"></i>
                </div>
                <div style="display: flex;flex-direction: column;">
                  <p v-for="(text, i) in item.list" :key="i">{{ text }}</p>
                </div>
              </div>
            </div>
            <div class="line" style="margin-top: 40px">
              <sharedWarehouseLine ref="sharedWarehouseLine"></sharedWarehouseLine>
            </div>
          </div>
          <div v-show="currentCloudWareType === 2">
            <div class="apply">
              <div>
                海外云仓&nbsp;&nbsp;
                提供一站式海外仓服务
              </div>
              // 不要的
              <!-<div class="apply_btn" @click="applyShareWarehouse">申请共享仓</div>->
            </div>
            <div class="advantage" :style="`background: url(${ossPath}/pages/home/cloud-ware-ad-bg.png) no-repeat`">
              <div v-for="(item, index) in golobalYunWarehouseAdvantage" :key="index" style="display: flex;" :style="item.style">
                <div style="width: 15px;height: 15px;border-radius: 50%;background-color: #422D1E;display: flex;align-items: center;margin-right: 3px;margin-top: 4px;">
                  <i class="el-icon-check" style="color: #FFCBAF;line-height: 1;font-weight: bold;font-size: 14px;"></i>
                </div>
                <div style="display: flex;flex-direction: column;">
                  <p v-for="(text, i) in item.list" :key="i">{{ text }}</p>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px; padding: 10px; background: #FFFFFF; border-radius: 8px">
              // 不要的
              <!- <quotation-item style="margin-bottom: 10px" :quotation="{}"></quotation-item>
              <quotation-item style="margin-bottom: 10px" :quotation="{}"></quotation-item>
              <quotation-item style="margin-bottom: 10px" :quotation="{}"></quotation-item>
              <quotation-item :quotation="{}"></quotation-item> ->
              <quotation-carousel v-if="globalCloudWareQuotationList.length" :list="globalCloudWareQuotationList" @checkItem="checkQuotation"></quotation-carousel>

              <div v-else style="padding: 100px 0; line-height: 20px; text-align: center; font-size: 16px;">
                <img style="width: 100px; margin-bottom: 20px" :src="ossPath + '/pages/sharedWarehouse/empty-pic.png'" alt="">
                <p>敬请期待</p>
              </div>
            </div>
            <quotation-details :visible="quotationVisible" :dataInfo="quotationDetailsInfo" @close="closeQuotation"/>
            // 不要的
            <!- <div class="apply_btn" @click="applyShareWarehouse">
              申请使用云仓
              <img :src="ossPath + '/pages/home/yun_warehouse/icon_apply_arrow_w.png'" alt="" style="width: 9px;height: 15px;margin-left: 4px;">
            </div> ->
          </div>

          <div class="apply_btn" @click="applyShareWarehouse">
            申请使用云仓
            <img :src="ossPath + '/pages/home/yun_warehouse/icon_apply_arrow_w.png'" alt="" style="width: 9px;height: 15px;margin-left: 4px;">
          </div>
        </div>
      </div> -->

      <!-- 一明TMS -->
      <!-- <div style="clear: both"></div>
      <div class="member-zone">
        <div class="Hotmemberzone">
          <img :src="ossPath + '/pages/home/yiming_banner_new.png'" alt="" style="width: 100%;"/>
          <a class="clickable-area" style="bottom: calc(22%); left: calc(17%);" href="https://www.yimingsaas.com/" target="_blank"></a>
        </div>
      </div> -->

      <!-- 云仓推广 -->
      <!-- <div style="clear: both"></div>
      <div class="member-zone">
        <div class="Hotmemberzone">
          <img :src="ossPath + '/pages/home/yun_warehouse/home-yuncnag.png?v=2'" alt="" style="width: 100%;"/>
          <div class="clickable-area" style="bottom: calc(0%); left: calc(43%);" @click="applyShareWarehouse"></div>
        </div>
      </div> -->

      <!-- 热门国家 -->
      <div style="clear: both"></div>
      <div class="hot-city">
<!--        <img class="city-bg" :src="ossPath + '/pages/home/country/bg.png'" alt="">-->
        <div class="Hotwrap" style="margin-top: 0px;">
          <div style="padding-top: 30px;  width: 1200px; margin: 0 auto;">
            <template v-if="hotCountryList.length || hotCountryList2.length">
              <div style="text-align: center;">
                <img :src="ossPath + '/pages/home/country/title3.png'" alt="">
              </div>
              <div class="hot-country-list-box">
                <!-- <div class="" style="margin-bottom: 25px;display: flex;align-items: center;padding-right: 26px;">
                  <el-tabs v-model="hotCountryTabsCurrent" @tab-click="changeHotCountryType" class="hot-country-tabs flex-1">
                    <el-tab-pane :label="`已上线(${hotCountryTotal})`" name="1"></el-tab-pane>
                    <el-tab-pane :label="`筹备中(${hotCountryTotal2})`" name="2"></el-tab-pane>
                  </el-tabs>
                  <div class="look-private-line-quotation">
                    <div class="look-label">平台已有<span style="color: #FF2823;">{{ privateQuotationNumber || 0 }}</span>条报价</div>
                    <div class="look-btn" @click="showPrivateLinesQuotation" >立即查看></div>
                  </div>
                </div> -->
                <div style="position: relative">
                  <country-tabs ref="hotCountryTab" :list="[{transportSchemeName: `已上线(${hotCountryTotal})`, id: '1'}, {transportSchemeName: `筹备中(${hotCountryTotal2})`, id: '2'}]" @change="changeHotCountryType" class="scheme"></country-tabs>
                  <div class="look-private-line-quotation" style="position: absolute;right: 10px;bottom: 20px; border-radius: 50px">
                      <div class="look-label">平台已有<span style="color: #FF4D01;">{{ privateQuotationNumber || 0 }}</span>条报价</div>
                      <div class="look-btn" style="border-radius: 50px" @click="showPrivateLinesQuotation">
                        立即查看
                        <img :src="ossPath + '/pages/home/country/icon_arrow_now.png'" alt="" style="margin-left: 4px;">
                      </div>
                    </div>
                </div>
                <div style="margin-bottom: 25px;">
                  <seven-continents-tabs
                    tabIdName="countryTab"
                    :list="hotCountryTabsCurrent === '1' ? hotCountryList : hotCountryList2"
                    :default-select.sync="currentContinentValue"
                    @change="changeContinentType"
                  />
                </div>
                <!--<div v-show="hotCountryTabsCurrent === '2'" style="padding: 0 26px;margin-bottom: 15px;">
                  <div class="hot-country-hit">平台上线首日3.10上线26个国家,计划3月底上线到39个国家,后续每月上线13个国家,到8月底上线到100个国家左右</div>
                </div>-->
                <home-hot-country
                  :list="currentHotCountryList"
                  key="hot_country_1"
                  @clickItem="item => setHotcity(item, false,'覆盖国家')"
                  @concern="gethotcity"
                  @cancelConcern="gethotcity"
                />

              </div>
            </template>
            <!--<div
              style="
                float: left;
                width: 100%;
                margin-top: 40px;
                margin-bottom: 20px;
                position: relative;
              "
            >
               <div id="homeCountryLine" @click="getCountrycount('US')">
                <img style="width: 100%" :src="ossPath + '/pages/home/country/line.png'" alt="国家专线报价一览表" />
                 <img src="@/assets/setBill.png" alt="国家专线报价一览表" />
                 <img class="gif-pointer" src="@/assets/pointer.gif" alt srcset />
                 <div class="trigger-button"></div>
              </div>


            </div>-->
          </div>
        </div>
      </div>

      <!-- 我们的优势 -->
      <platform-advantages></platform-advantages>

      <el-drawer
        title="查看专线报价一览表"
        custom-class="private-lines-quotation-drawer"
        :show-close="false"
        :visible.sync="visiblePrivateLinesQuotation"
        direction="rtl"
        :lock-scroll="true"
        :before-close="hidePrivateLinesQuotation"
        append-to-body
        :withHeader="false"
        size="1100px">
        <div class="quotation-drawer-box">
          <start-end-check
            class="quotation-drawer-header"
            :default-start-select="startCityActive"
            :startData="startData"
            :endContinentsData="hotRecommendCountryTabs"
            :loading-city="startDataLoading"
            :loading-tabs="hotRecommendCountryTabsLoading"
            @changeStart="changeTableStartCity"
            @changeEnd="change26CountryContinentType"
          >
            <export-report :loading="exportLoading" @hideLoading="exportLoading = false" @showLoading="exportLoading = true" style="margin-right: 12px;">
              <el-button :loading="exportLoading" type="primary" plain size="mini" underline round>下载报价表</el-button>
            </export-report>
            <el-button
              type="primary"
              round
              size="mini"
              icon="el-icon-close"
              @click="visiblePrivateLinesQuotation = false"
            >关闭</el-button>
          </start-end-check>
          <home-hot-recommend-country-product-list
            :header-cell-style="{ background: '#FF4D01', color: '#fff' }"
            :list="hotRecommendCountryCurrentList"
            :loading-list="hotRecommendCountryCurrentListLoading"
            @clickItem="val=> clickHotRecommend(val,'country')"
            @checkVideo="videoPreview"
          />
        </div>

      </el-drawer>
      <!-- 热门推荐 -->
      <div style="clear: both"></div>
<!--      <div class="home-common-box hot-recommend" style="position: relative" v-if="hotRecommendList.length || hotRecommendCountryTabs.length">
        <div class="home-common-title">
          <img :src="ossPath + '/pages/home/product_list_title.png'" alt="">
        </div>
        <div style="margin-bottom: 10px; text-align: right; font-size: 18px; z-index: 1;">
          <export-report :loading="exportLoading" @hideLoading="exportLoading = false" @showLoading="exportLoading = true">
            <el-button :loading="exportLoading" type="primary" underline>下载报价表</el-button>
          </export-report>
        </div>
&lt;!&ndash;        <el-tabs v-model="hotRecommendTabsCurrent" @tab-click="handleClick">&ndash;&gt;
&lt;!&ndash;          <el-tab-pane :label="`美国${hotRecommendList.length||0}个FBA仓整柜直送`" name="1"></el-tab-pane>&ndash;&gt;
&lt;!&ndash;          <el-tab-pane :label="`${hotRecommendCountryNumber||0}个专线报价一览表`" name="2"></el-tab-pane>&ndash;&gt;
&lt;!&ndash;        </el-tabs>&ndash;&gt;
        <div v-show="hotRecommendTabsCurrent === '1'">
          <home-hot-recommend-warehouse-product-list
            :list="hotRecommendList"
            @clickItem="val=> clickHotRecommend(val,'warehouse')"
          />
        </div>
        <div v-show="hotRecommendTabsCurrent === '2'">
          <div style="margin-bottom: 10px;">
            &lt;!&ndash; <seven-continents-tabs
              :list="hotRecommendCountryTabs"
              :default-select.sync="hotRecommendCountryCurrentValue"
              @change="change26CountryContinentType"
            /> &ndash;&gt;
            <start-end-check
              :default-start-select="startCityActive"
              :startData="startData"
              :endContinentsData="hotRecommendCountryTabs"
              @changeStart="changeTableStartCity"
              @changeEnd="change26CountryContinentType"
            ></start-end-check>
          </div>
          <home-hot-recommend-country-product-list
            :list="hotRecommendCountryCurrentList"
            @clickItem="val=> clickHotRecommend(val,'country')"
            @checkVideo="videoPreview"
          />
          <video-preview :visible="videoVisible" :src="videoSrc" :poster="videoPoster" @close="videoVisible = false; videoSrc = ''; videoPoster = ''"></video-preview>
        </div>

      </div>-->

      <!-- 优势对比 -->
      <div v-show="!topType">
        <!-- <Compare></Compare> -->
      </div>
      <!-- 服务流程 -->
      <div v-show="!topType">
        <!-- <Service></Service> -->
      </div>
      <!-- <div v-show="!topType">
        <Weadvantage></Weadvantage>
      </div>-->
      <!--公司介绍 + 视频-->
      <!-- <div class="home-video__warp" v-show="!topType">
        <div
          class="home-video__container"
          style="
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="home-video__left" style="padding-right: 110px">
            <h3 class="home-video__title">货代拼</h3>
            <div class="home-video__description">
              <p>货代拼，亦邦国际物流旗下“全球数字物流服务平台”。为亚马逊卖家提供门到门的一站式数字化+O2O的物流运收服务及体验。</p>
              <p>平台集线上查价、下单、轨迹于一体，从上门揽收至末端派送为一套，最大程度减少卖家FBA物流运营负担，提升物流履约效率。</p>
              <p>货代拼秉承“全球到门，一键查价”的服务宗旨，为您的国货出海运送到门，保驾护航。</p>
            </div>
            <span class="home-video__go" @click="toTop">查看平台介绍</span>
          </div>
          <div class="home-video__right my-video" style="min-width: 200px">
            <video
              id="myVideo"
              controls
              loop
              src="https://jiuyu-pro.oss-cn-hongkong.aliyuncs.com/vedio/vedio.mp4"
            ></video>
            <template v-if="videoLoadingStatus">
              <div class="video-button" v-if="videoPayStatus" @click="pauseVideo">
                <el-icon class="el-icon-video-pause"></el-icon>
              </div>
              <div class="video-button" v-else @click="playVideo">
                <el-icon class="el-icon-video-play"></el-icon>
              </div>
            </template>
          </div>
        </div>
      </div> -->

      <!-- 新闻中心 -->
       <news-module v-show="!topType"></news-module>

       <line-product-detail
        :visible.sync="ProgType"
        :countData="countData"
        :theadData="theadData"
        :tableData="tableData"
        :deliveryTheadData="deliveryTheadData"
        :deliveryTableData="deliveryTableData"
        :BillItem="BillItem"
        :payType="payType"
        :type="ProgType"
        :val="typeTips"
        :is-transfer="!!BillItem.domDTO"
        :before-to-country-name="beforeToCountryName"
      ></line-product-detail>
      <!-- <el-dialog width="1200px" :visible.sync="ProgType" :close-on-click-modal="false" :lock-scroll="false">
        <GetitemBill
          v-if="ProgType"
          :countData="countData"
          :theadData="theadData"
          :tableData="tableData"
          :deliveryTheadData="deliveryTheadData"
          :deliveryTableData="deliveryTableData"
          :BillItem="BillItem"
          :payType="payType"
          :type="ProgType"
          :val="typeTips"
          :isTransfer="isTransfer"
          :before-to-country-name="beforeToCountryName"
        ></GetitemBill>
      </el-dialog> -->
    </div>
    <!-- <el-drawer
      class="drawer"
      style="overflow: auto"
      :visible.sync="gridData"
      :withHeader="false"
      direction="rtl"
      size="1000"
    >
      <div
        style="
          width: 100%;
          float: left;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 0 50px;
        "
      >
        <div class="card_wrap">
          <div class="flex" style="align-items: center; margin-bottom: 10px">
            <span> 当前国家： </span>
            <el-select
              v-model="whereCountryid"
              @change="getCountrycount"
              placeholder="请选择"
            >
              <el-option
                v-for="item in cityCount"
                :key="item.id"
                :label="item.namec"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <div class="flex-1"></div>
            <el-button
              type="primary"
              round
              size="mini"
              icon="el-icon-close"
              @click="gridData = false"
              >关闭
            </el-button>
          </div>
          <el-table
            :data="lableCountry"
            border
            :header-cell-style="{ background: '#da6874', color: '#fff' }"
            style="width: 1100px"
          >
            <el-table-column
              prop="productName"
              align="center"
              label="产品名称"
              width="180"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="introduction"
              label="产品简介"
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p style="max-width: 500px">
                    产品简介: {{ scope.row.introduction }}
                  </p>
                  <div slot="reference" class="name-wrapper">
                    <div
                      v-show="scope.row.introduction"
                      size="medium"
                      style="
                        max-width: 200px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ scope.row.introduction }}
                    </div>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="aging" align="center" label="参考时效">
            </el-table-column>
            <el-table-column label="运费" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.currency }}</span>
                <span>{{ scope.row.priceinfo }}起</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="报价链接" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="showText(scope.row, true, 2)"
                  type="text"
                  size="small"
                  >点击查价</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>-->

    <div v-show="!topType">
      <!-- <div style="background-color: #FFFFFF;" :style="{background: `url(${ossPath + '/pages/home/servive-part-bg.png'}) no-repeat 100% 100%`, backgroundSize: 'cover'}">
        <div class="page-size-container" style="padding: 102px 0 30px;">
          <div style="text-align: center; margin-bottom: 60px">
            <img :src="ossPath + '/pages/home/service-process.png'" alt="">
          </div>
          <service-process style="margin-bottom: 80px;"></service-process>
        </div>
      </div> -->
        <!--<platform-advantages/>-->
    </div>

    <Billdrawer :gridData="gridData" :labelData="labelData" ref="mychild"></Billdrawer>
    <get-coupon ref="getCoupon"></get-coupon>
    <!-- <questionnaire-bar v-if="token && !Authorization.isQuestionnaireFilling"></questionnaire-bar> -->

    <video-preview :visible="videoVisible" :src="videoSrc" :poster="videoPoster" @close="videoVisible = false; videoSrc = ''; videoPoster = ''"></video-preview>
    <blockPublishInquiry :visible="blockvisible" @close="blockvisible = false" />

    <cannot-place-order :show.sync="showCannotPlaceOrder" :servicePicUrl="contactServiceUrl"></cannot-place-order>
  </div>
</template>

<script>
import BScroll from "better-scroll"
import Driver from "driver.js"
import Utils from "../../../common/util.js"
import loginType from "../../../common/loginType"
import FBAicon3 from "../../assets/icon_fba.png"
import FBAicon4 from "../../assets/icon_tabs.png"
import FBAicon11 from "../../assets/icon_fba11.png"
import FBAicon12 from "../../assets/icon_fba12.png"
import FBAicon13 from "../../assets/icon_fba13.png"
import FBAicon14 from "../../assets/icon_fba14.png"
import {
  findChildrenItem,
  sendCustomerOperationRecord,
  sendStatisticHotCountry,
  setArrayChildrenLevel
} from "../../assets/js/utils"
// import logoFloat from "../../../common/logoFloat";
import Weadvantage from "./placeindexInfo/Weadvantage.vue"
// import BillText from "./placeindexInfo/BillText.vue"
import GetitemBill from "./placeindexInfo/GetitemBill.vue"
import lineProductDetail from "./placeindexInfo/lineProductDetail.vue";
import Service from "./placeindexInfo/Service.vue"
import { myVideo } from "@/components/placeOrder/components/video"
import NewsModule from "@/components/placeOrder/placeindexInfo/newsModule"
// 小包组件
import Packet from "@/components/home/packet"
import Billdrawer from "./placeindexInfo/Billdrawer.vue" // 专线报价查询
// 优势对比
import Compare from "@/components/placeOrder/placeindexInfo/Compare"
import ServiceProcess from "@/components/placeOrder/components/serviceProcess";
import ServiceText from "@common/serviceText";
import PlatformAdvantages from "@/components/placeOrder/components/platformAdvantages";
import HomeQueryLogisticsProducts from "@/components/placeOrder/components/homeQueryLogisticsProducts";
import {isArray, isObject} from "my-tools-kit";
import HomeHotCountry from "@/components/placeOrder/components/homeHotCountry";
import HomeHotRecommendCountryProductList
  from "@/components/placeOrder/components/homeHotRecommend/homeHotRecommendCountryProductList";
import HomeHotRecommendWarehouseProductList
  from "@/components/placeOrder/components/homeHotRecommend/homeHotRecommendWarehouseProductList";
import PriceBlurring from "../../../common/priceBlurring";
import {sortRecommendList} from "../../../common/priceBlurring/utils";
import exportReport from '../../../common/exportReport'
import SevenContinentsTabs from "@/components/placeOrder/components/homeHotCountry/sevenContinentsTabs";
import startEndCheck from "@/components/placeOrder/components/homeHotRecommend/startEndCheck";
import GetCoupon from "../../../common/getCoupon";
import questionnaireBar from "../../../common/questionnaireBar"
import {mapGetters, mapState} from "vuex";
import {confirmGoRealName} from "@/assets/js/utils.realName";
import videoPreview from '@common/videoPreview'
import {resetHotCountryStartCity} from "@/components/placeOrder/utils.home";
import {getBannerList} from "../../../common/requestBaseData";
import ScrollMessageRow from "@/components/placeOrder/components/scrollMessageRow";
import fa from "element-ui/src/locale/lang/fa";
import GlobalPriceComparison from "@/components/placeOrder/components/globalPriceComparison";
import sharedWarehouseLine from "@/components/placeOrder/components/sharedWarehouseLine/home";
import quotationCarousel from './components/globalCloudWareQuotation/quotationCarousel.vue'
import quotationDetails from './components/globalCloudWareQuotation/quotationDetails.vue'
// 热门比价
import countryTabs from "./components/countryTabs.vue";
import homeHotPriceCompare from "./components/homeHotPriceCompare/index.vue";
import homeProductTabs from "./components/homeProductTabs.vue";
import inquiryQueryHomeBar from "./components/inquiryQueryBar/home-query.vue"
import homeInquiryFba from "./components/inquiryQueryBar/home-inquiry-fba.vue"
import homeInquiryNotfba from "./components/inquiryQueryBar/home-inquiry-notfba.vue"
import blockPublishInquiry from './components/blockPublishInquiry'
import HomeHotMemberZone from "@/components/placeOrder/components/homeHotMemberZone";
import CannotPlaceOrder from "../../../common/cannot-place-order.vue"


export default {
  mixins: [myVideo],
  components: {
    ScrollMessageRow,
    GlobalPriceComparison,
    GetCoupon,
    SevenContinentsTabs,
    PriceBlurring,
    HomeHotRecommendWarehouseProductList,
    HomeHotRecommendCountryProductList,
    HomeHotCountry,
    HomeQueryLogisticsProducts,
    // loginType,
    Billdrawer,
    // BillText,
    lineProductDetail,
    GetitemBill,
    Weadvantage,
    Service,
    NewsModule,
    Packet,
    Compare,
    ServiceProcess,
    ServiceText,
    PlatformAdvantages,
    exportReport,
    questionnaireBar,
    startEndCheck,
    videoPreview,
    sharedWarehouseLine,
    homeHotPriceCompare,
    countryTabs,
    homeProductTabs,
    inquiryQueryHomeBar,
    blockPublishInquiry,
    homeInquiryFba,
    homeInquiryNotfba,
    quotationCarousel,
    quotationDetails,
    HomeHotMemberZone,
    CannotPlaceOrder
  },
  data () {
    const ossPath = this.ossPath;
    return {
      queryType: 1,
      blockvisible: false,
      exportLoading: false,
      ossPath,
      startPlaceList: [],
      startCitylist: [],
      labelData: {},
      hotsmallLIst: [],
      activeName: "first",
      typeInfo: 1, // 1-首页  2-进入页
      showTag: 0,
      showTag1: 0,
      showCurrent: null,
      showIndex: -1,
      // =1时，查看详情弹窗显示"功能栏"（包括下单按钮）
      typeTips: 1,
      // 查看详情默认为true 没查找到使用的地方
      payType: false,
      // 查看详情时，部分详情接口没有的数据，从此处取值回显
      BillItem: {},
      isShow: false,
      editableTabs: [{ label: "国家", name: "country", list: [] }],
      listHeight: [],
      scrollY: 0, //实时获取当前y轴的高度
      clickEvent: false,
      rightList: [],
      letters: [],
      listHeight1: [],
      scrollY1: 0, //实时获取当前y轴的高度
      clickEvent1: false,
      rightList1: [],
      letters1: [],
      isIndeterminate: false,
      checkAll: false,
      warehouseStroe: [],
      activeprovince: "province",
      activeStar: "",
      activecountry: "country",
      show1: false,
      show2: false,
      show3: false,
      loadingStoreList: false,
      gridData: false,
      isQueryLowestPrice: false,
      setColor: -1,
      countryData: {},
      AllCount: [], //国家list
      searchType: false,
      itemWrap: {},
      isTransfer: false,
      countData: {},
      theadData: [],
      tableData: [],
      NodisType: true,
      hotcityLIst: [],
      hotStyleLIst: [],
      // 产品详情弹窗
      ProgType: false,
      transportCodes: [],
      transportQuery: "ALL",
      goodstypeId: 0,
      transportTypeQueryList: [],
      TransportationcheckLisy: [],

      props: {
        value: "namec",
        label: "namec",
      },
      checked1: false,
      checked2: false,
      whereCountryid: "", //国家id
      Typelist: [
        { name: "FBA", icon: FBAicon3, index: 3 },
        // { name: "电商小包", icon: FBAicon4,  index: 4 },
        // { name: "国际空运", icon: FBAicon11,  index: 11 },
        // { name: "散货拼箱", icon: FBAicon12,  index: 12 },
        // { name: "海运整柜", icon: FBAicon13,  index: 13 },
        // { name: "海外仓", icon: FBAicon14,  index: 14 },
      ],
      thatALLcklist: [],

      FBAtoCk: [], //  FBA 目的地
      Sonindex: 3, // FBA 电商小包 （对应值 Typelist[x].index）
      activeIndex: null,
      topType: false,
      lableData: [],
      lableCountry: [],
      WarehouseList: [],
      activeType: 0,
      weight: "",
      PricesHeader: [],
      PricesCount: [],
      cityCount: [],
      provinceList: [],
      fromstoreName: "",
      tostoreName: "",
      tocountryName: "",
      fromProvinceid: "", //起运省id
      fromCityid: "", //起运城市id
      toCountryid: "", //目的地国家id
      toStoreid: "", //目的仓库id
      counryChildren: [],
      showTive: false,
      showWarehouseStroe: false,
      showActivecountry: false,
      showFormCity: false,
      toWarehouseInfo: {},
      /* 头部筛选表单tab */
      productTabCurrent:"1",
      productTabList: [
        { title: 'FBA', code: '1' },
        { title: '海运专线', code: '2' },
        { title: '空运专线', code: '3' },
        { title: '陆运专线', code: '4' },
      ],

      deliveryTheadData: [],
      deliveryTableData: [],
      agingType: {
        1: '开船后开始计算时效',
        2: '入仓后开始计算时效'
      },

      /* 热门国家 */
      // 当前热门国家类型 1-已上线 2-筹备中
      hotCountryTabsCurrent:"1",
      // 已上线
      hotCountryList:[],
      hotCountryTotal:0,
      // 筹备中
      hotCountryList2:[],
      hotCountryTotal2:0,
      // 当前七大洲tab类型 all-全部
      currentContinentValue:"",
      // 当前热门国家列表
      currentHotCountryList:[],
      // 热门推荐 1：美国xx个FBA仓整柜直送  2：xx个专线报价一览表
      hotRecommendTabsCurrent:"2",
      // 21个仓
      hotRecommendList: [],
      // 26个国家 tabs
      hotRecommendCountryTabs: [],
      hotRecommendCountryCurrentValue:"",
      hotRecommendCountryTabsLoading:false,
      // 26个国家 总数量
      hotRecommendCountryNumber:0,
      // 26个国家 当前展示列表
      hotRecommendCountryCurrentList:[],
      hotRecommendCountryCurrentListLoading:false,
      // 26个国家 起运城市列表当前项
      startCityActive: '',
      // 26个国家 起运城市列表
      startData: [],
      startDataLoading:false,
      // 视频预览
      videoVisible: false,
      // 视频路径
      videoSrc: '',
      // 视频封面
      videoPoster: '',
      // 首页滚动消息
      topMessageList: [],
      topMessageLoading:false,
      // 全球比价tabs
      globalPriceComparisonTabs: [],
      priceComparisonTabsLoading:false,
      // 全球比价某条线路列表 弹窗
      visiblePriceComparison:false,
      // 某条比价线路tabItem { title,id}
      currentPriceComparisonTabItem:null,
      // 某条比价线路tabItem下的线路列表
      priceComparisonList:[],
      priceComparisonListLoading:false,
      compareBaseInfo: {
        toCountryName: '',
        cityName: '',
        transportSchemeName: '',
        toCitiNames: ''
      },
      // 目的国家（当为多国家时，regionType === 6，查看详情需要保存当前目标的目的国家参数）
      beforeToCountryName:"",
      // 查看报价（专线报价一览表）
      visiblePrivateLinesQuotation:false,
      privateQuotationNumber:0,
      yunWarehouseAdvantage: [
        {
          list: ['免费仓租，免卸货费，转仓内专线免装货费', '免费仓租，免卸货费，转仓外专线装货费30元/CBM'],
          style: 'margin-right: 68px'
        },
        {
          list: ['上门提货服务'],
          style: 'margin-right: 140px'
        },
        {
          list: ['一键全球FBA专线特价选择'],
          style: 'margin-right: 69px'
        },
        {
          list: ['二十个整柜直送仓全网超低价']
        }
      ],
      golobalYunWarehouseAdvantage: [
        {
          list: ['多点布仓，更快送达', '美西、美东多点布仓，就近分仓，保证时效'],
          style: 'margin-right: 68px'
        },
        {
          list: ['头仓配一体化'],
          style: 'margin-right: 140px'
        },
        {
          list: ['智能匹配最优尾程']
        }
      ],
      currentCloudWareType: 1,
      inquiryBusinessType: 1,
      globalCloudWareQuotationList: [],
      quotationVisible: false,
      quotationDetailsInfo: {},
      oriTop: 0,
      showCannotPlaceOrder: false,
      contactServiceUrl: ''
    }
  },
  watch: {
    "$store.state.tag" (newVal, oldVal) {
      console.log("55555abc", newVal)
      this.gethotstyle()
      this.gethotcity()
    },
    showTag1 (newVal, oldVal) {
      console.log("showTag1", newVal)
    },
    topType: function (val, oldval) {
      if (val) {
        this.show1 = false
        this.show2 = false
        this.show3 = false
      } else {
        this.goodstypeId = 0
      }
    },
    show3 (newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.listHeight = []
          this.scrollY = 0 //实时获取当前y轴的高度
          this.clickEvent = false
          this._initScroll()
          this._getHeight()
        }, 500)
      }
    },
    show1 (newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.listHeight1 = []
          this.scrollY1 = 0 //实时获取当前y轴的高度
          this.clickEvent1 = false
          this._getHeight1()
          this._initScroll1()
        })
      } else {
        this.stopScroll()
      }
    },
    // "$store.state.dialogShow"(newVal, oldVal) {
    //   console.log("xxxx", newVal);
    //   // this.visiable = newVal
    //   this.getGudie();
    // },
    token(value){
      console.log("首页 watch token",value)
      if(value){
        if(this.$route.path === "/"){
          console.log("首页 watch token","需要获取优惠券")
          if(this.$refs.getCoupon && this.$refs.getCoupon.getCouponList) this.$refs.getCoupon.getCouponList();
        }
      } else {
        this.queryType = 1
      }
    },
    isOpen:{
      immediate:true,
      handler(newVal){
        if(!newVal) return false;
        this.getPriceComparisonTabList();
      },
    },
    currentCloudWareType(val) {
      if (val === 2) this.getGCloudWareQuotation()
      if (val === 1) this.$refs.sharedWarehouseLine.getSharedWarehouseLine()
    }
  },
  computed: {
    ...mapGetters(["token","realNameState","homePageBanner"]),
    ...mapState(["Authorization","isOpen"]),
    isSelected () {
      if (this.checked1 || this.checked2) {
        return false
      }
      return true
    },
    select () {
      return 1
    },
    loopList() {
      const list = []
      let item = []
      if (!this.hotcityLIst) return []
      this.hotcityLIst.forEach((v, i) => {
        item.push(v)
        console.log(Math.abs((i + 1) % 12))
        if(Math.abs((i + 1) % 12)) {
          if (i + 1 === this.hotcityLIst.length) list.push(item)
        } else {
          list.push(item)
          item = []
        }
      });
      return list
    },
  },
  methods: {
    checkQuotation(item) {
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      this.oriTop = document.documentElement.scrollTop
      let {
        overseasWarehouseId,
        overseasCityId,
        portId,
        cabinetId,
        customsClearanceId,
        liftingDismantlingId,
        quotationType,
        deliveryPriceList
      } = item
      const data = {
        overseasWarehouseId,
        overseasCityId,
        portId,
        cabinetId,
        customsClearanceId,
        liftingDismantlingId,
        quotationType,
        deliveryPriceList: deliveryPriceList.map(v => {
          return {
            id: v.id,
            deliveryType: v.deliveryType
          }
        })
      }
      console.log(data)
      this.quotationVisible = true
      this.axios.post('/fbaTailCourseCloudWarehouseQuotation/getOverseasCloudWarehouseQuotationDetail', data).then(res => {
        if (res.data.code === 200) {
          console.log(res.data.data)
          this.quotationDetailsInfo = res.data.data
        }
      })
    },
    closeQuotation() {
      this.quotationVisible = false
      this.quotationDetailsInfo = {}
      setTimeout(() => {
        console.log(this.oriTop)
        document.documentElement.scrollTop = this.oriTop
      }, 300)
    },
    getGCloudWareQuotation() {
      // /fbaTailCourseCloudWarehouseQuotation/overseasCloudWarehouseQuotationList
      this.axios.post('/fbaTailCourseCloudWarehouseQuotation/overseasCloudWarehouseQuotationList', {}).then(res => {
        if (res.data.code === 200) {
          this.globalCloudWareQuotationList = res.data.datas
        }
      })
    },
    inquiryShow() {
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      if (this.Authorization.authenticationInfoDTO.type != '1' || this.Authorization.authenticationInfoDTO.state != '3') return this.blockvisible = true
      this.queryType = 2
    },
    /**
     * 发布询盘
     */
    handlePublished(data) {
      // if (!this.token) {
      //   this.$root.Bus.$emit("showDialog", 0, true);
      //   return
      // }
      // if (this.Authorization.authenticationInfoDTO.type != '1' || this.Authorization.authenticationInfoDTO.state != '3') return this.blockvisible = true
      // const query = {}
      // Object.keys(data).forEach(v => {
      //   query[v] = JSON.stringify(data[v])
      // })
      // this.$router.push({
      //   name: 'publishedInquiry',
      //   query
      // })
    },
    getUsertypeRap(item, store, type) {
      console.log("去下单？？？", 'hhhh');
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      this.contactServiceUrl = item.wxUrl
      this.showCannotPlaceOrder = true
      return
      sessionStorage.removeItem('toFABck')
      if (store) {
        sessionStorage.setItem("toFABck", JSON.stringify(store));
      }
      if (!this.sessionGetUserInfo().token) {
        this.$root.Bus.$emit("showDialog", 0, true);
      } else {
        sendCustomerOperationRecord("立即下单(热门线路)",`${item.productName}`, { productId: item.productId });
        let customerId = this.sessionGetUserInfo().customerid;
        this.axios
          .get(`/corporation/checkCustomerIsAvailable/${customerId}`)
          .then((res) => {
            if (res.data.code == 200) {
              if (type === 'rowPrice') this.handlePriceClick(item)
              else this.handleNewClick(item);
            } else {
              return this.$message({
                message: "该账号暂未通过审核，请联系客服人员",
                type: "warning",
                offset: "500",
              });
            }
          })
          .catch((res) => {});
      }
    },
    handlePriceClick(item) {
      let tuoCheDataChecked = false;
      if (item.toWarehouseInfo) {
        sessionStorage.setItem("toFABck", JSON.stringify(item.toWarehouseInfo));
      } else {
        sessionStorage.removeItem('toFABck')
      }
      if (!item.fromCityId && item.polCityId) item.fromCityId = item.polCityId
      if (!item.cityList && item.polCityId) {
        item.cityList = [{
          id: item.polCityId,
          cityName: item.polCityName
        }]
      }
      if (!item.cityList && item.fromCityId) {
        item.cityList = [{
          id: item.fromCityId,
          cityName: item.cityName
        }]
      }
      item.toCountryid = item.countryId || item.toCountryid
      item.toCountryName = this.beforeToCountryName || item.countryName || item.toCountryname
      // if (item.fromCityInfo) {
      //   item.cityName = item.fromCityInfo.namec
      //   item.fromCityId = item.fromCityInfo.id
      //   item.cityList = [{
      //     id: item.fromCityInfo.id,
      //     cityName: item.fromCityInfo.namec
      //   }]
      // }
      // if (item.toSelectId) {
      //   item.countryId = item.toSelectId[0] || ''
      //   item.toCountryid = item.toSelectId[0] || ''
      //   item.toStoreid = item.toSelectId[1] || ''
      // }
      // item.productPriceHeaderId = item.priceHeaderId || item.productPriceHeaderId || ''

      // // item.volumeWeightRatio
      // // item.weightVolumeRatioDesc
      // // item.deliveryType
      // // item.warehouseAddress
      // // item.warehouseContactPerson
      // // item.warehouseContactTel
      // // item.selfDelivery
      // item.selfAddress = item.overseasWarehouseAddress || ''
      // item.selfContacts = item.overseasWarehouseContactPerson || ''
      // item.selfTelephone = item.overseasWarehouseContactPhone || ''

      sessionStorage.setItem("goodsTypeName", item.goodsTypeNames ? JSON.stringify(item.goodsTypeNames) : '');
      sessionStorage.setItem("itemWrap", JSON.stringify(item));
      sessionStorage.setItem("fromCityid", item.fromCityId ? JSON.stringify(item.fromCityId) : '');
      sessionStorage.setItem("transportTypeCode", item.transportTypeCode || '');
      sessionStorage.removeItem("countLIst_T");
      console.log('xxxxxxxxxxxxx', item)
      // if (item.isFBA) {
      //   sessionStorage.setItem("isPrivate", JSON.stringify(false))
      //   this.$router.push({
      //     name: "newBillCargo",
      //     query: {
      //       THFtype: tuoCheDataChecked,
      //       transportTypeCode: item.transportTypeCode,
      //       productPriceHeaderId: item.productPriceHeaderId,
      //       supplierId: item.carrierId ? item.carrierId : '',
      //       toCountryid: item.countryId || item.toCountryid,
      //       itemWrap: item,
      //     },
      //   });
      // } else {
      //   sessionStorage.setItem("isPrivate", JSON.stringify(true))
      //   this.$router.push({
      //     name: "privateBill",
      //     query: {
      //       THFtype: tuoCheDataChecked,
      //       transportTypeCode: item.transportTypeCode,
      //       productPriceHeaderId: item.productPriceHeaderId,
      //       supplierId: item.carrierId ? item.carrierId : '',
      //       toCountryid: item.countryId || item.toCountryid,
      //       toCityId: '',
      //       itemWrap: item,
      //       postcode: ''
      //     },
      //   });
      // }
      // item.isPrivateAddress = !item.isFBA
      const routerUrl = this.$router.resolve({
          path: "/takeOrder",
          query: {
            THFtype: tuoCheDataChecked,
            transportTypeCode: item.transportTypeCode,
            productPriceHeaderId: item.productPriceHeaderId,
            supplierId: item.carrierId ? item.carrierId : '',
            toCountryid: item.countryId || item.toCountryid,
            toCityId: '',
            itemWrap: item,
            postcode: '',
            goodsTypeNames: item.goodsTypeNames
          },
      });
      window.open(routerUrl.href, '_blank')
    },
    handleNewClick(item) {
      //去下单
      let tuoCheDataChecked = false;
      if (item.toWarehouseInfo) {
        sessionStorage.setItem("toFABck", JSON.stringify(item.toWarehouseInfo));
      }
      if (item.fromCityInfo) {
        item.cityName = item.fromCityInfo.namec
        item.fromCityId = item.fromCityInfo.id
        item.cityList = [{
          id: item.fromCityInfo.id,
          cityName: item.fromCityInfo.namec
        }]
      }
      if (item.toSelectId) {
        item.countryId = item.toSelectId[0] || ''
        item.toCountryid = item.toSelectId[0] || ''
        item.toStoreid = item.toSelectId[1] || ''
      }
      item.productPriceHeaderId = item.priceHeaderId || item.productPriceHeaderId || ''

      // item.volumeWeightRatio
      // item.weightVolumeRatioDesc
      // item.deliveryType
      // item.warehouseAddress
      // item.warehouseContactPerson
      // item.warehouseContactTel
      // item.selfDelivery
      item.selfAddress = item.overseasWarehouseAddress || ''
      item.selfContacts = item.overseasWarehouseContactPerson || ''
      item.selfTelephone = item.overseasWarehouseContactPhone || ''
      item.toCountryName = this.beforeToCountryName || item.toCountryName

      sessionStorage.setItem("goodsTypeName", JSON.stringify(item.goodsTypeNames));
      sessionStorage.setItem("itemWrap", JSON.stringify(item));
      sessionStorage.setItem("fromCityid", JSON.stringify(item.fromCityInfo.id));
      if (item.transportType) sessionStorage.setItem("transportTypeCode", item.transportType);
      sessionStorage.removeItem("countLIst_T");
      console.log({
            THFtype: tuoCheDataChecked,
            transportTypeCode: item.transportType,
            productPriceHeaderId: item.productPriceHeaderId,
            supplierId: item.carrierId ? item.carrierId : '',
            toCountryid: this.toCountryid,
            toCityId: this.toStoreid,
            itemWrap: item,
            postcode: this.toStoreid
          })
      sessionStorage.setItem("isPrivate", JSON.stringify(false));
      console.log('xxxxxxxxxxxxx', item)
      // this.$router.push({
      //   name: "newBillCargo",
      //   query: {
      //     THFtype: tuoCheDataChecked,
      //     transportTypeCode: item.transportTypeCode,
      //     productPriceHeaderId: item.productPriceHeaderId,
      //     supplierId: item.carrierId ? item.carrierId : '',
      //     toCountryid: this.toCountryid,
      //     itemWrap: item,
      //   },
      // });
      const routerUrl = this.$router.resolve({
          path: "/takeOrder",
          query: {
            THFtype: tuoCheDataChecked,
            transportTypeCode: item.transportTypeCode,
            productPriceHeaderId: item.productPriceHeaderId,
            supplierId: item.carrierId ? item.carrierId : '',
            toCountryid: this.toCountryid,
            toCityId: '',
            itemWrap: item,
            postcode: ''
          },
      });
      window.open(routerUrl.href, '_blank')
    },
    handleClickHot (tab, event) {
      console.log("tab---", this.activeName)
      if (this.activeName == "first") {
      } else {
        // 获取小包数据
        this.smallInit()
      }
    },
    smallInit () {
      this.axios
        .post("/ies/jiuyu/getProductByPopularLine")
        .then((res) => {
          console.log("hot-line", res)
          if (res.data.code == 200) {
            this.hotsmallLIst = res.data.datas
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            })
          }
        })
        .catch((res) => { })
    },
    // 取关
    /**
     * 取消 收藏(关注)
     * @param item
     * @param num {number}  取消目标类型  1——热门线路  2——覆盖国家
     * @constructor
     */
    CancelAttention (item, num) {
      console.log("123")
      if(num === 1){
        sendCustomerOperationRecord(`取消收藏`,`产品名称：${item.productName}`)
      }else if(num === 2){

      }
      // /api/product/cancelConcernProductOrCountry
      let data = {
        productOrCountryId: num == 1 ? item.productId : item.countryId,
        refType: num,
      }
      this.axios
        .post("/api/product/cancelConcernProductOrCountry", data)
        .then((res) => {
          console.log("countryId", res)
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "取消收藏",
            })
            if (num == 1) {
              this.gethotstyle()
              this.$root.Bus.$emit('refreshFavoritesLineProduct')
            } else {
              this.gethotcity()
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            })
          }
        })
        .catch((res) => {
          // this.$message.info("服务器繁忙");
        })
    },
    // 关注
    followItemHot (item) {
      console.log("点击收藏item: ", item)
      if (item.concernSign) {
        //取消关注
        this.CancelAttention(item, 1)
        return
      }
      if(this.token){
        if(this.realNameState !== 3) {
          confirmGoRealName(this.realNameState);
          return false;
        }
      }
      sendCustomerOperationRecord("收藏",`产品名称：${item.productName}`)
      let data = {
        productOrCountryId: item.productId,
        refType: 1,
      }
      this.axios
        .post("/api/product/concernProductOrCountry", data)
        .then((res) => {
          console.log("countryId", res)
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "收藏成功",
            })
            this.$root.Bus.$emit('refreshFavoritesLineProduct')
            this.gethotstyle()
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            })
          }
        })
        .catch((res) => {
          // this.$message.info("服务器繁忙");
        })
    },
    // 国家关注
    followItem (item) {
      console.log("item: ", item)
      if (item.concernSign) {
        //取消关注
        this.CancelAttention(item, 2)
        return
      }
      console.log("item-prodcut", item)
      let data = {
        productOrCountryId: item.countryId,
        refType: 2,
      }
      this.axios
        .post("/api/product/concernProductOrCountry", data)
        .then((res) => {
          console.log("countryId", res)
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "收藏成功",
            })
            this.gethotcity()
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            })
          }
        })
        .catch((res) => {
          // this.$message.info("服务器繁忙");
        })
    },
    handleShowInidex () {
      this.show3 = !this.show3
      this.show2 = false
      this.show1 = false
      // console.log("6666", this.currentIndex);
    },
    stopScroll () {
      this.rights1 = new BScroll(this.$refs.right1, {
        probeType: 3, //探针的效果，实时获取滚动高度
        mouseWheel: true, // 开启鼠标滚轮模式
        disableMouse: true,
        // click: true,
      })
      this.rights1.on("scrollEnd", () => {
        console.log("scrollEnd")
      })
    },
    _initScroll1 () {
      // console.log("_initScroll");
      this.lefts1 = new BScroll(this.$refs.left1, {
        click: true,
        mouseWheel: true,
        // tap: true,
      })
      this.rights1 = new BScroll(this.$refs.right1, {
        probeType: 3, //探针的效果，实时获取滚动高度
        mouseWheel: true, // 开启鼠标滚轮模式
        disableMouse: true,
        // click: true,
      })
      this.rights1.on("scroll", (pos) => {
        this.scrollY1 = Math.abs(Math.round(pos.y))
        for (let i = 0; i < this.listHeight1.length; i++) {
          let height = this.listHeight1[i]
          let height2 = this.listHeight1[i + 1]
          if (
            !height2 ||
            (this.scrollY1 >= height && this.scrollY1 < height2)
          ) {
            this.showTag1 = i
            return i
          }
          if (
            this.listHeight1[this.listHeight1.length - 1] -
            this.$refs.right1.clientHeight <=
            this.scrollY1
          ) {
            if (this.clickTrue) {
              return this.currentNum
            } else {
              this.showTag1 = this.listHeight1.length - 1
              return this.listHeight1.length - 1
            }
          } else {
            this.showTag1 = 0
          }
        }
      })
    },
    _initScroll () {
      // console.log("_initScroll");
      this.lefts = new BScroll(this.$refs.left, {
        click: true,
        mouseWheel: true,
        // tap: true,
      })
      this.rights = new BScroll(this.$refs.right, {
        probeType: 3, //探针的效果，实时获取滚动高度
        mouseWheel: true, // 开启鼠标滚轮模式
        disableMouse: true,
        // click: true,
      })
      this.rights.on("scroll", (pos) => {
        this.scrollY = Math.abs(Math.round(pos.y))
        for (let i = 0; i < this.listHeight.length; i++) {
          let height = this.listHeight[i]
          let height2 = this.listHeight[i + 1]
          if (!height2 || (this.scrollY >= height && this.scrollY < height2)) {
            this.showTag = i
            return i
          }
          if (
            this.listHeight[this.listHeight.length - 1] -
            this.$refs.right.clientHeight <=
            this.scrollY
          ) {
            if (this.clickTrue) {
              return this.currentNum
            } else {
              this.showTag = this.listHeight.length - 1
              return this.listHeight.length - 1
            }
          } else {
            this.showTag = 0
          }
        }
      })
    },
    _getHeight1 () {
      let rightItems =
        this.$refs.right1.getElementsByClassName("right-item-hook1")
      console.log("3333", rightItems)
      let height = 0
      this.listHeight1.push(height)
      for (let i = 0; i < rightItems.length; i++) {
        let item = rightItems[i]
        height += item.clientHeight
        this.listHeight1.push(height)
      }
      console.log("this.listHeight1", this.listHeight1)
    },

    _getHeight () {
      let rightItems =
        this.$refs.right.getElementsByClassName("right-item-hook")
      let height = 0
      this.listHeight.push(height)
      for (let i = 0; i < rightItems.length; i++) {
        let item = rightItems[i]
        height += item.clientHeight
        this.listHeight.push(height)
      }
    },
    selectItem (index, event, item) {
      console.log("fba点击私人地址", index, item)
      // this.showCurrent = item
      // this._initScroll()
      // this.showTag = index
      // this._getHeight()
      // debugger
      this.clickEvent = true
      // this.currentIndex = index
      //在better-scroll的派发事件的event和普通浏览器的点击事件event有个属性区别_constructed
      //浏览器原生点击事件没有_constructed所以当时浏览器监听到该属性的时候return掉
      if (!event._constructed) {
        return
      } else {
        let rightItems =
          this.$refs.right.getElementsByClassName("right-item-hook")
        let el = rightItems[index]
        this.rights.scrollToElement(el, 300)
      }
    },
    selectItem1 (index, event) {
      this.clickEvent1 = true
      //在better-scroll的派发事件的event和普通浏览器的点击事件event有个属性区别_constructed
      //浏览器原生点击事件没有_constructed所以当时浏览器监听到该属性的时候return掉
      // debugger
      if (!event._constructed) {
        return
      } else {
        let rightItems = this.$refs.right1.getElementsByClassName("right-item-hook1")
        let el = rightItems[index]
        this.rights1.scrollToElement(el, 300)
      }
    },

    transportChange () {
      this.transportCodes = []
      if (this.transportQuery == "ALL") {
        this.isIndeterminate = false
        this.checkAll = true
        this.TransportationcheckLisy.forEach((item) => {
          this.transportCodes.push(item.value)
        })
      } else {
        this.isIndeterminate = false
        this.checkAll = false
        this.transportCodes.push(this.transportQuery)
      }
      // console.log(this.transportCodes);
    },

    getStoreid (item, index, index1, item2, val) {
      //fba点击目的仓库
      this.typeInfo = val
      console.log("fba点击目的仓库", item)
      this.toWarehouseInfo = item
      this.showIndex = item.namec
      this.showTag = index
      // this.showTag1 = index;
      this.showWarehouseStroe = false
      this.tostoreName = item.namec
      this.toStoreid = item.id
      this.show3 = false
      this.isShow = false
      sessionStorage.setItem("toFABck", JSON.stringify(item))
      this.listHeight = []
    },
    startFromstore (tab, event) {
      //fba 点击私人地址
      this.tostoreName = "私人地址"
      this.toStoreid = "-1"
      this.show3 = false
      this.isShow = false
    },
    Qdcity (item) {
      console.log("item: ", item)
      this.showFormCity = false
      this.fromstoreName = item.namec
      this.fromCityid = item.id
      this.show1 = false
      this.show2 = true
      // this.getFBAcount();
      sessionStorage.setItem("fromCityid", this.fromCityid)
    },
    showType (num) {
      this.showTag = 0
      this.showTag1 = 0
      this.showIndex = 0
      console.log("num==", num)
      if (num == 1) {
        //回到首页
        this.searchType = false //返回首页查询默认还是根据仓库查询
        this.NodisType = true
        this.topType = false
        this.thatALLcklist = []
        this.letters = []
        this.rightList = []
        this.tocountryName = ""
        this.tostoreName = ""
        this.toCountryid = ""
        this.toStoreid = ""
        let formCityInfo = {};
        if(isArray(this.startPlaceList) && this.startPlaceList.length){
          let first = this.startPlaceList[0];
          if(isObject(first) && isArray(first.fromCityDTOList) && first.fromCityDTOList.length){
            let first2 = first.fromCityDTOList[0];
            if(isObject(first2)) formCityInfo = first2
          }
        }
        this.fromCityid = formCityInfo.id //默认城市id
        this.fromstoreName = formCityInfo.namec
        sessionStorage.setItem("fromCityid", this.fromCityid)
        this.TransportationcheckLisy.forEach((item) => {
          this.transportCodes.push(item.value)
        })
        this.checkAll = true
        this.transportQuery = "ALL"
        this.showActivecountry = false
        this.showTive = false
        this.showWarehouseStroe = false
        this.showFormCity = false
      }
      this.lableData = []
      this.letters = []
      this.warehouseStroe = []
    },
    getStoredata (item) {
      //查询仓库
      this.loadingStoreList = true
      this.axios
        .get(`/warehouse/getFBAAndPrivateWarehouseList?countryId=${item.id}`)
        .then((res) => {
          let warehouseData = {
            warehouseCodeGroup: "私人地址",
            codeWarehouseList: [],
          }
          this.warehouseStroe = res.data.datas
          console.log("this.warehouseStroe: ", this.warehouseStroe)
          this.warehouseStroe.push(warehouseData)
          this.activeStar = this.warehouseStroe[0].warehouseCodeGroup
          this.letters = []
          this.rightList = []
          this.warehouseStroe.map((item) => {
            this.letters.push(item.warehouseCodeGroup)
          })
          this.letters.pop()
          let arrList = []
          let arr = []
          this.warehouseStroe.map((item) => {
            item.codeWarehouseList.map((_item) => {
              _item.warehouseDTOList.map((item_1) => {
                arr.push({
                  namec: item_1.namec,
                  id: item_1.id,
                  address: item_1.address,
                  children: item_1.children,
                  city: item_1.city,
                  country: item_1.country,
                  countryCode: item_1.countryCode,
                  type: item_1.type,
                })
              })
            })
            arrList.push({
              letters: item.warehouseCodeGroup,
              content: [...arr],
            })
            arr = []
          })
          this.rightList.push(...arrList)
          this.rightList.pop()
          this.loadingStoreList = false
        })
        .catch((res) => {
          this.letters = []
          this.rightList = []
          this.loadingStoreList = false
        })
    },
    handleClick (tab) {
      if (tab.name == "country") {
        this.editableTabs.pop()
      }
    },
    handleClickTips () { },
    changeCountry (item, level = 1) {
      this.showActivecountry = false
      this.toCountryid = ""
      this.tostoreName = ""
      this.toStoreid = ""
      // 目的仓库联动清空数组
      this.listHeight = []
      if (item.children) {
        this.counryChildren = item.children
        let obj = { label: "分区", name: "city", list: [] }
        obj.list = item.children
        this.editableTabs[1] = obj
        this.activecountry = "city"
      } else {
        if (level === 1) {
          // 点击国家时，清空可能存在的分区数据
          this.counryChildren = []
          if (this.editableTabs.length > 1) this.editableTabs.splice(1, 1)
          // this.activecountry = "country";
        }
        this.toCountryid = item.countryId //目的国家id
        this.tocountryName = item.namec
        this.whereCountryid = item.countryId //用于专线报价查询
        this.show3 = true
        this.isShow = true
        this.show2 = false

        sessionStorage.setItem("formCountryName", JSON.stringify(item.namec))
        this.getStoredata(item)
      }
    },
    // getCitydata () {
    //   this.axios
    //     .get(`/filedata/findAllCountryExcludeCN`)
    //     .then((res) => {
    //       this.cityCount = res.data.datas
    //     })
    //     .catch((res) => { })
    // },

    changeSettype (value) {
      let checkedCount = value.length
      this.checkAll = this.TransportationcheckLisy.length === checkedCount
      this.isIndeterminate =
        this.TransportationcheckLisy > 0 &&
        checkedCount < this.transportCodes.length
      if (!this.searchType) {
        if (value.length > 0) {
          this.getFBAcount(true)
        } else {
          this.lableData = []
        }
      } else {
        this.getCountrycount()
      }
    },
    setHotcity (item, type, name) {
      console.log("item: ", item,type,name)
      // 清空目的地相关信息
      item = Object.assign({},item)
      item.toWarehouseInfo = undefined;
      if(isArray(item.toSelectId)) {
        item.toSelectId[1] = "";
      }
      if(isArray(item.toThreeSelectId)) {
        item.toThreeSelectId[1] = "";
        item.toThreeSelectId[2] = "";
      }
      if(name === "覆盖国家"){
        sendCustomerOperationRecord("覆盖国家",`${item.countryNamec||""}`);
        if(!isObject(item.fromCityInfo)) return this.$message.error(`该国家报价已失效，请选择其它国家查看`)
        // item = resetHotCountryStartCity(item); // 覆盖国家跳转专线大厅取有报价的起运城市不重置为默认起运城市

        // 起运城市代码
        let startCityCode = item.fromCityInfo.code || "";
        // 目的国家代码
        let endCountryCode = item.countryCode||"";
        sendStatisticHotCountry(startCityCode,endCountryCode);
      }

      this.$router.push({
        name: "queryPrice",
        query: {
          itemData: JSON.stringify(item),
          type: JSON.stringify(type),
          name: JSON.stringify(name),
        },
      })
    },
    pathSmallbag (item, type) {
      //跳转到小包查价页面
      console.log("item: ", item)
      let data = {
        depCityCode: item.departureCityCode, // 起运地，取城市代码
        desCountryCode: item.destinationCountryCode, // 目的地，取国家代码
        goodsType: "", // 货物类型， ALL:全部，PH：普货，MH：敏货
        lineType: "", // 线路类型
      }
      let startEnd = {
        start: item.departureCityNameCn,
        end: item.destinationCountryNameCn,
        info: item.productNameCn,
      }
      this.$router.push({
        name: "Smallbag",
        query: {
          itemData: JSON.stringify(item),
          objData: JSON.stringify(data),
          info: JSON.stringify(startEnd),
        },
      })
    },
    findAllCountryExcludeCN () {
      //查询国家
      this.axios
        .get("/filedata/findAllCountryExcludeCN")
        .then((res) => {
          this.AllCount = res.data.datas
        })
        .catch((res) => { })
    },
    changeimg (item) {
      // item.imgurl = item.whitePicUrl;
    },
    mouseLeave (item) {
      // item.imgurl = item.picUrl;
    },
    getAllTransportTypes () {
      this.axios
        .get("/fbxData/getAllTransportTypes")
        .then((res) => {
          this.TransportationcheckLisy = JSON.parse(
            JSON.stringify(res.data.datas)
          )
          this.TransportationcheckLisy.forEach((item) => {
            this.transportCodes.push(item.value)
            this.isIndeterminate = false
            this.checkAll = true
          })
          let allObj = {
            name: "全部",
            value: "ALL",
          }
          this.transportTypeQueryList = res.data.datas
          this.transportTypeQueryList.unshift(allObj)
        })
        .catch((res) => { })
    },
    closeDrawer () {
      this.gridData = false
    },
    getCountrycount (name) {
      //根据国家查询报价
      if (name == "US") {
        this.thatALLcklist = this.hotcityLIst[0].fromSelectId
        this.whereCountryid = this.hotcityLIst[0].toSelectId[0]
      } else {
        this.checked1 = false
        this.checked2 = false
      }

      this.labelData = {
        fromCityId: this.thatALLcklist[1], //起运城市id,
        toCountryId: this.whereCountryid, //目的地国家
        goodstypeId: this.goodstypeId,
        transportCodes: this.transportCodes,
      }
      this.$nextTick(()=>{
        this.gridData = true;
      })
    },
    getFBAcount (Type) {
      // FBA查询报价
      this.checked1 = false
      this.checked2 = false
      if (this.fromCityid == "") {
        this.showFormCity = true
        return
      }
      // this.TransportationcheckLisy.forEach((item) => {
      //   this.transportCodes.push(item.value);
      // });
      let searchData = {
        fromstoreName: this.fromstoreName, //起运地名字
        tocountryName: this.tocountryName, //目的地名字
        fromProvinceid: this.fromProvinceid, // 起运省id
        fromCityid: this.fromCityid, //起运城市id
        toCountryid: this.toCountryid, //目的国家id
        tostoreName: this.tostoreName, // 目的仓名字
        toStoreid: this.toStoreid, // 目的仓库id
        toWarehouseInfo: this.toWarehouseInfo,
        transportQuery: this.transportCodes,
      }
      this.$router.push({
        name: "queryPrice",
        query: {
          searchData: JSON.stringify(searchData),
          tag: JSON.stringify(this.showTag),
          name: JSON.stringify(this.showIndex),
        },
      })
      let params = {}
      // params = {
      //   pollandId: this.fromCityid, //入仓仓库id,
      //   podlandId: this.toStoreid, //目的仓库
      //   customerId: this.sessionGetUserInfo().customerid, //客户id
      //   goodstypeId: this.goodstypeId,
      //   transportCodes: this.transportCodes,
      //   isQueryLowestPrice: this.isQueryLowestPrice,
      //   toCountryId: this.toCountryid,
      // };
      // this.axios
      //   .post("/FBAfee/queryFBAQuotedPriceInfo", params)
      //   .then((res) => {
      //     if (res.data.code == "200") {
      //       if (res.data.datas.length > 0) {
      //         // this.NodisType = false;
      //         this.lableData = res.data.datas;
      //         let searchData = {
      //           fromstoreName: this.fromstoreName, //起运地名字
      //           tocountryName: this.tocountryName, //目的地名字
      //           fromProvinceid: this.fromProvinceid, // 起运省id
      //           fromCityid: this.fromCityid, //起运城市id
      //           toCountryid: this.toCountryid, //目的国家id
      //           tostoreName: this.tostoreName, // 目的仓名字
      //           toStoreid: this.toStoreid, // 目的仓库id
      //           toWarehouseInfo: this.toWarehouseInfo,
      //           transportQuery: this.transportQuery,
      //         };
      //         this.$router.push({
      //           name: "queryPrice",
      //           query: {
      //             searchData: JSON.stringify(searchData),
      //             tag: JSON.stringify(this.showTag),
      //             name: JSON.stringify(this.showIndex),
      //           },
      //         });
      //         // this.showTive = false;
      //       } else {
      //         this.lableData = [];
      //         this.showTive = true;
      //       }
      //     } else {
      //       // this.$message(res.data.message);
      //     }
      //   })
      //   .catch((res) => {});
    },

    getFiledata () {
      this.showTive = false
      console.log('this.toCountryid', this.toCountryid)
      if (!this.toCountryid) {
        this.showActivecountry = true
        return
      }
      if (!this.toStoreid) {
        this.showWarehouseStroe = true
        return
      }
      this.searchType = false
      if (this.Sonindex == 3 || this.Sonindex == 11 || this.Sonindex == 12) {
        //调用fba查价
        this.getFBAcount()
      }
    },
    // 修改tab
    changesonNav (index) {
      console.log("index---", index)
      // if([13,14].includes(index)){
      //   this.$message.warning("系统开发中 ,敬请期待.如需走货可联系平台客服或业务员!");
      //   return false;
      // }
      if (index != this.Sonindex) {
        this.lableData = []
        this.topType = false
      }
      this.Sonindex = index
      this.lableData = []
    },

    showText(item, type, val) {
      console.log("item---", item)
      this.typeTips = val
      this.payType = type
      this.BillItem = item
      if (!this.sessionGetUserInfo().token)
        return this.$root.Bus.$emit("showDialog", 0)
      let url = ""
      if (type) {
        url = `/FBAfee/queryQuotedPriceDetailInfo?productPriceHeaderId=${item.productPriceHeaderId||""}&fromCityId=${item.polCityId||""}&podlandType=0` + (item.lineCityId ? `&transEndCityId=${item.lineCityId}` : '')
      } else {
        url = `/FBAfee/queryQuotedPriceDetailInfo?podlandId=${this.toStoreid}&productPriceHeaderId=${item.productPriceHeaderId}&fromCityId=${this.fromCityid}` + (item.lineCityId ? `&transEndCityId=${item.lineCityId}` : '')
      }
      this.axios
        .get(url)
        .then((res) => {
          this.ProgType = true;
          if(item.regionType === 6) this.beforeToCountryName = item.countryName || "";
          else this.beforeToCountryName = "";
          this.countData = res.data.data || {};
          let labelList = [
            { label: item.pickUpFlag ? '免费上门提货' : '', desc: '' },
            { label: item.goodsMeasurementMethod === 1 ? '机器量方' : '皮尺量方', desc: '' },
            { label: item.whetherSupportedCompensate ? '时效赔付' : '', desc: item.supportedCompensateDesc || item.compensationStandards },
            { label: item.whetherSupportCompensation ? '丢货赔付' : '不支持丢货赔付', desc: item.supportCompensationDesc || item.compensationStandards },
            { label: item.whetherGuaranteedDelivery ? '限时达' : '', desc: '' },
            { label: item.label1, desc: item.label1Desc },
            { label: item.label2, desc: item.label2Desc },
            { label: item.label3, desc: item.label3Desc },
          ]
          labelList = labelList.filter(v => v.label)
          item.labelList = labelList
          this.countData = {
            ...this.countData,
            carrierLogoUrl: item.carrierLogoUrl,
            carrierAbbr: item.carrierAbbr,
            labelList: item.labelList,
            aging: item.aging,
            agingType: item.agingType
          }
          if (isArray(this.countData.transPriceDomList) && this.countData.transPriceDomList.length) {
            this.isTransfer = true
          } else {
            this.isTransfer = false
          }
          console.log("this.countData: ", this.countData)
          if (res.data.data) {
            this.getAttr();
            this.setDeliveryPrices()
          } else {
            this.theadData = []
            this.tableData = []
            this.deliveryTheadData = []
            this.deliveryTableData = []
          }
          // console.log("11=", this.ProgType);
        })
        .catch((res) => { })
    },
    getAttr () {
      this.theadData = this.countData.productRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        }
      })
      console.log("99999---", this.theadData)
      let tableData = []
      let list = this.countData.productRegionPrices.map(item => item)
      list.splice(0, 1)
      // this.sortQuotationList(list)
      list.forEach((item, index) => {
        let obj = {}
        item.map((_item, index) => {
          obj["name" + index] = this.parseDiscountsPrice(_item)
        })
        tableData.push(obj)
      })
      this.tableData = tableData
      // this.tableData.splice(0, 1)
      console.log("tableData", this.tableData)
    },
    setDeliveryPrices() {
      // deliveryRegionPrices
      if (!this.countData.deliveryRegionPrices) {
        this.deliveryTheadData = []
        this.deliveryTableData = []
        return false
      }
      this.deliveryTheadData = this.countData.deliveryRegionPrices[0].map((c, i) => {
        return {
          label: c,
          prop: "name" + i,
        };
      });
      console.log("99999---", this.deliveryTheadData);
      let tableData = [];
      let list = this.countData.deliveryRegionPrices.map(item => item)
      list.splice(0, 1)
      // this.sortQuotationList(list);
      list.forEach((item, index) => {
        let obj = {};
        item.map((_item, index) => {
          obj["name" + index] = _item;
        });
        tableData.push(obj);
      });
      this.deliveryTableData = tableData;
      // this.deliveryTableData.splice(0, 1);
      console.log("tableData", this.deliveryTableData);
    },
    parseDiscountsPrice(text){
      let haveN = `${text||""}`.match("\n");
      if(haveN){
        let obj = {
          type:"price",
        };
        let arr = text.split("\n");
        obj.discountsPrice = arr[0];
        obj.originPrice = arr[1];
        return obj
      }
      return text;
    },
    /**
     * 给物流产品详情接口返回的报价列表排序
     */
    sortQuotationList(list = []){
      list.sort((item1,item2)=>{
        let cityName1 = item1[0]||"";
        let cityName2 = item2[0]||"";
        let regionName1 = item1[1]||"";
        let regionName2 = item2[1]||"";
        let goodsTypeText1 = item1[2]||"";
        let goodsTypeText2 = item2[2]||"";
        if(cityName1 !== cityName2){
          if(cityName1 > cityName2){
            return 1
          }else if(cityName1 < cityName2){
            return -1
          }else{
            return 0
          }
        }
        if(regionName1 !== regionName2){
          if(regionName1 > regionName2){
            return 1
          }else if(regionName1 < regionName2){
            return -1
          }else{
            return 0
          }
        }
        if(goodsTypeText1 !== goodsTypeText2){
          if(goodsTypeText1 > goodsTypeText2){
            return 1
          }else if(goodsTypeText1 < goodsTypeText2){
            return -1
          }else{
            return 0
          }
        }
        return 0;
      });
    },
    // //急速下单
    // handleNewClick (item) {
    //   let tuoCheDataChecked = false
    //   sessionStorage.setItem("goodsTypeName", JSON.stringify(item.goodstype))
    //   sessionStorage.setItem("itemWrap", JSON.stringify(item))
    //   sessionStorage.setItem(
    //     "transportTypeCode",
    //     JSON.stringify(item.transportTypeCode)
    //   )
    //   sessionStorage.removeItem("countLIst_T")
    //   if (this.tostoreName == "私人地址") {
    //     sessionStorage.setItem("isPrivate", JSON.stringify(true))
    //     this.$router.push({
    //       name: "privateBill",
    //       query: {
    //         THFtype: tuoCheDataChecked,
    //         transportTypeCode: item.transportTypeCode,
    //         productPriceHeaderId: item.productPriceHeaderId,
    //         toCountryid: this.toCountryid,
    //         itemWrap: item,
    //       },
    //     })
    //   } else {
    //     sessionStorage.setItem("isPrivate", JSON.stringify(false))
    //     this.$router.push({
    //       name: "newBillCargo",
    //       query: {
    //         THFtype: tuoCheDataChecked,
    //         transportTypeCode: item.transportTypeCode,
    //         productPriceHeaderId: item.productPriceHeaderId,
    //         toCountryid: this.toCountryid,
    //         itemWrap: item,
    //       },
    //     })
    //   }
    // },
    /**
     * 获取专线报价一览表的起运城市列表
     */
    getFBAStartPlace () {
      this.startDataLoading = true;
      this.axios.post("/filedata/findSortedFromCity", {})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.startDataLoading = false;
          console.log("起运地: ", res)
          let list = res.datas || [];
          list.sort((a, b) => {
            return a.sort - b.sort
          })
          const szCity = list.find(v => {
            return v.namec && v.namec.includes('深圳')
          })
          this.startData = list;
          this.$nextTick(()=>{
            let currentCityId = szCity ? szCity.id : list[0].id;
            this.startCityActive = currentCityId;
            sendCustomerOperationRecord('覆盖国家', `起运地：${szCity.namec}，查看报价一览表`)
            if(currentCityId) this.get26CountryTabs();
          })
        })
        .catch((res) => {
          this.startDataLoading = false;
        })
    },

    getFBAtoCk () {
      //获取fba仓库
      this.axios
        .get("/filedata/findCountryAndEUCity")
        .then((res) => {
          this.FBAtoCk = res.data.datas
          this.editableTabs[0].list = res.data.datas
        })
        .catch((res) => { })
    },
    /**
     * 切换 覆盖国家（热门国家）类型
     */
    changeHotCountryType(item){
      console.log(item)
      if (item && item.id) {
        this.hotCountryTabsCurrent = item.id
      }
      setTimeout(() => {
        let tabItem = null;
        if(this.hotCountryTabsCurrent === "1"){
          tabItem = this.hotCountryList[0];
        }else if(this.hotCountryTabsCurrent === "2"){
          tabItem = this.hotCountryList2[0];
        }
        if(tabItem){
          this.currentContinentValue = tabItem.value||"";
          this.changeContinentType(tabItem.value,tabItem);
        }else{
          this.currentContinentValue = "";
          this.currentHotCountryList = [];
        }
      }, 0)
    },
    /**
     * 切换 覆盖国家（热门国家） 七大洲tab类型
     */
    changeContinentType(val = "",tabItem = ""){
      let sonList = tabItem.list || [];
      let list = this.groupHotCountryList(sonList);
      this.currentHotCountryList = list;
    },
    /**
     * 获取 覆盖国家（热门国家）数据
     */
    gethotcity () {
      this.axios.post(`/api/FBAfee/queryFBAHotState`)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          let list = res.datas|| [];

          let all = [];
          list.forEach(continentItem=>{
            let sonList = continentItem.dataList || [];
            sonList.forEach(item=>{
              item.imgurl = item.picUrl;
              if (item.countryCode === "US") this.countryData = item;
              if(item.status === 1) all.push(item);
            })
          })

          let {
            alreadyList,
            alreadyTotal,
            afootList,
            afootTotal,
          } = this.disposeHotCountryList(list);

          this.hotcityLIst = all;
          this.hotCountryList = alreadyList;
          this.hotCountryTotal = alreadyTotal;
          this.hotCountryList2 = afootList;
          this.hotCountryTotal2 = afootTotal;
          this.changeHotCountryType()
        })
        .catch(res => {
          this.hotcityLIst = [];
          this.hotCountryList = [];
          this.hotCountryTotal = 0;
          this.hotCountryList2 = [];
          this.hotCountryTotal2 = 0;
        })
    },
    /**
     * 处理 覆盖国家（热门国家）数据
     * @param list
     * @returns {{alreadyList: *[], afootList: *[]}}
     */
    disposeHotCountryList(list = []){
      // 已上线
      let alreadyList = [];
      let alreadyTotal = 0;
      // 筹备中
      let afootList = [];
      let afootTotal = 0;

      let _id = 0;
      list.forEach(continentItem=>{
        // let continentItemObj = {
        //   label: continentItem.continentName||"未知的",
        //   value: continentItem.id||`local_${_id++}`,
        //   list: [],
        //   total: 0,
        // };
        let continentItemObj = {
          label: continentItem.continentName||"全部",
          value: continentItem.id||`all`,
          list: [],
          total: 0,
        };
        let arr1 = [];
        let arr2 = [];
        let sonList = continentItem.dataList || [];
        sonList.forEach(item=>{
          // item.imgurl = item.picUrl;
          // if (item.countryCode === "US") this.countryData = item;
          if(item.status === 1){
            arr1.push(item);
          }else{
            arr2.push(item);
          }
        })
        alreadyList.push(Object.assign({},continentItemObj,{
          list:arr1,
          total:arr1.length,
        }))
        afootList.push(Object.assign({},continentItemObj,{
          list:arr2,
          total:arr2.length,
        }))
      })
      alreadyList = this.continentListSort(alreadyList, 'label')
      afootList = this.continentListSort(afootList, 'label')


      // let alreadyAllItem = this.mergeContinentNameAll(alreadyList);
      // alreadyList.unshift(alreadyAllItem);
      let alreadyAllItem = alreadyList.find(item=>item.value === "all");
      alreadyTotal = alreadyAllItem.list.length;

      // let afootAllItem = this.mergeContinentNameAll(afootList);
      // afootList.unshift(afootAllItem)
      let afootAllItem = afootList.find(item=>item.value === "all");
      afootTotal = afootAllItem.list.length;

      return {
        alreadyList,
        alreadyTotal,
        afootList,
        afootTotal,
      }
    },
    /**
     * 传入七大洲二级列表, 合并返回“全部”项
     */
    mergeContinentNameAll(list=[]){
      let arr = [];
      list.forEach(item => {
        let sonList = item.list || [];
        arr.push(...sonList);
      })
      // arr = [].concat(arr,arr,arr) // 测试用
      let allItem = {
        label: "全部",
        value: "all",
        list:arr,
        total:arr.length,
      };
      return allItem;
    },
    /**
     * 热门国家单个list数据 轮播视图分组
     * @param originList
     * @returns {*[]}
     */
    groupHotCountryList(originList = []){
      let list = [];
      let itemArr = [];
      originList.forEach((item,index)=>{
        itemArr.push(item);
        if((index+1)%12){
          if((index+1) === originList.length) list.push(itemArr);
        }else{
          list.push(itemArr);
          itemArr = [];
        }
      })
      return list;
    },
    gethotstyle () {
      console.log("热门路线被调用")
      this.axios
        .post(`/FBAfee/queryFBAHotLine`)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then((res) => {
          let list = res.datas|| [];
          this.hotStyleLIst = list;
          console.log(this.hotStyleLIst);
        })
        .catch((res) => { })
    },

    getWarehouse () {
      this.axios
        .get("/warehouse/overseasWarehouseList")
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then((res) => {
          let list = res.datas|| [];
          this.WarehouseList = list;
        })
        .catch((res) => { })
    },

    // 在线咨询
    onlineConsultation () {
      window.open(
        "https://p.qiao.baidu.com/cps/chat?siteId=17320739&userId=34266456&siteToken=5e01b35862b5ca97b9b51380e3ae2b80",
        "_blank"
      )
    },
    /**
     * 21个仓整柜直送
     */
    getHotRecommendList(){
      let url = "/api/FBAfee/fullContainerDirectDeliveryList";
      let data = {

      };
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          let list = res.datas || [];
          if(this.$store.getters.realNameState !== 3) sortRecommendList(list);
          this.hotRecommendList = list;
        })
        .catch(res => {
          this.hotRecommendList = [];
        })
    },
    /**
     * 26个国家专线一览表
     */
    getHotRecommendList2(continentId = ""){
      let url = "/api/FBAfee/pageSpecialLines";
      if(continentId === "all") continentId = null;
      let data = {
        //目的国家id
        // toCountryId:"",
        // 洲id，为null时为全部
        cityId: this.startCityActive,
        continentId:continentId,
        // "customerId": "",
        // "goodstypeId": "",
        "pageNum": 1,
        "pageSize": 999,
        // "toCountryId": "",
        // "transportCodes": [],
      };
      return this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
    },
    /**
     * 获取26个国家专线一览表 七大洲tabs(表头数量)
     */
    get26CountryTabs(){
      let url = "/api/FBAfee/pageSpecialLinesCount";
      let data = {
        cityId: this.startCityActive,
      };
      this.hotRecommendCountryTabsLoading = true;
      return this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.hotRecommendCountryTabsLoading = false;
          let _id = 0;
          let list = res.datas || [];
          list = this.continentListSort(list, 'continentName')
          list = list.map(continentItem=>{
            return {
              label: continentItem.continentName||"未知的",
              value: continentItem.continentName === "全部" ? "all"  : (continentItem.continentId||`local_${_id++}`),
              list: [],
              total: continentItem.count || 0,
            }
          })
          this.hotRecommendCountryTabs = list;
          let first = list[0];
          if(first) {
            this.hotRecommendCountryNumber = first.total || 0;
            this.hotRecommendCountryCurrentValue = first.value;
            this.change26CountryContinentType(first.value,first);
          }else{
            this.hotRecommendCountryNumber = 0;
            this.hotRecommendCountryCurrentValue = "";
            this.hotRecommendCountryCurrentList = [];
          }
          return res;
        })
        .catch(res => {
          this.hotRecommendCountryTabsLoading = false;
          this.hotRecommendCountryNumber = 0;
          this.hotRecommendCountryTabs = [];
          this.hotRecommendCountryCurrentValue = "";
          this.hotRecommendCountryCurrentList = [];
        })
    },
    /**
     * 切换 26个国家 七大洲tab类型
     */
    change26CountryContinentType(val = "",tabItem = ""){
      let sonList = tabItem.list || [];
      if(sonList.length) this.hotRecommendCountryCurrentList = sonList;
      else {
        this.hotRecommendCountryCurrentListLoading = true;
        this.getHotRecommendList2(tabItem.value)
          .then(res=>{
            this.hotRecommendCountryCurrentListLoading = false;
            let list = res.data.records||[];
            if(this.$store.getters.realNameState !== 3) sortRecommendList(list);
            tabItem.list = list;
            this.hotRecommendCountryCurrentList = list;
          })
          .catch(res=>{
            this.hotRecommendCountryCurrentListLoading = false;
            this.$message.error(`获取${tabItem.label}下的报价列表：${res.message||"网络异常，请稍后重试"}`);
          })
      }

    },
    /**
     * 大洲排序并删除南极洲
     * @param list
     * @param key
     */
    continentListSort(list = [], key = 'continentName') {
      const sortedContinent = ['全部', '亚洲', '欧洲', '非洲', '北美洲', '南美洲', '大洋洲']
      list = list.filter(continentItem => continentItem[key] !== '南极洲')
      list = list.sort((a, b) => {
        const index1 = sortedContinent.findIndex(item => a[key] === item)
        const index2 = sortedContinent.findIndex(item => b[key] === item)
        return index1 - index2
      })
      return list
    },
    // 切换专线报价一览表起运地
    changeTableStartCity(cityId) {
      this.startCityActive = cityId
      this.get26CountryTabs(cityId)
      const city = this.startData.find(v => v.id === cityId)
      sendCustomerOperationRecord('覆盖国家', `起运地:${city.namec}，查看报价一览表`)
    },
    /**
     * 点击热门推荐
     * @param item
     * @param typeName  warehouse：xx个仓 country：xx个国家
     */
    clickHotRecommend(item,typeName=""){
      let text = "";
      if(typeName === "warehouse"){
        // text = "美国XX个FBA仓整柜直送,"
        text = `美国${this.hotRecommendList.length||0}个FBA仓整柜直送,`;
        sendCustomerOperationRecord("点击查价",text + `仓库名称:${item.warehousecode}`);
      }else{
        // text = "XX个专线报价一览表,"
        text = `${this.hotRecommendCountryNumber||0}个专线报价一览表,`;
        sendCustomerOperationRecord("点击查价",text + `产品名称:${item.productName}`, { productId: item.productId });
      }
      // 起运城市代码
      let startCityCode = item.polCode || "";
      // 目的国家代码
      let endCountryCode = item.countryCode||"";
      sendStatisticHotCountry(startCityCode,endCountryCode);
      this.showText(item,true,1);
    },
    videoPreview(item) {
      this.videoVisible = true
      this.videoSrc = item.videoUrl
      this.videoPoster = item.pictureUrl
      sendCustomerOperationRecord('产品培训视频', `${item.countryName}培训视频`)
    },
    // 获取banner
    getBanner() {
      /*this.axios.get('/api/banner/showBanner?type=1').then(res => {
        if (res.data.code === 200) {
          this.$store.commit('setBannerList', res.data.datas)
        }
      })*/
      getBannerList()
    },
    bannerJump(item) {
      console.log(item)
      if (!item.url) return
      let url = item.url
      if (!item.url.includes('http://') && !item.url.includes('https://')) {
        url = 'http://' + url
      }
      window.open(url, '_blank')
    },
    /**
     * 获取首页顶部滚动消息列表
     */
    getTopMessageList(){
      let url = "/api/homePageNotification/getNotificationList";
      let data = {};
      this.topMessageLoading = true;
      // this.getTestTopMessageList()
      this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.topMessageLoading = false;
          let list = res.datas || [];
          list.forEach(item=>{
            // 通知类型：1、新上国家 2、新上专线报价 3、更新价格
            let type = item.type;
            // 通知内容
            let content = item.content;
            let matchText;
            if(type === 1){
              matchText = item.countryName;
            }else if([2,3].includes(type)){
              matchText = item.price;
            }
            if(matchText || matchText === 0) matchText = `${matchText}`;
            if(matchText) content = content.replace(matchText,`<span class="markup-text">$&</span>`);
            item.label = content;
          })
          this.$nextTick(()=>{
            this.topMessageList = list;
          })
        })
        .catch(res=>{
          this.topMessageLoading = false;
          this.topMessageList = [];
        })
    },
    getTestTopMessageList(){
      return new Promise((resolve, reject) => {
        setTimeout(()=>{
          let list = Array(10).fill(1).map((item,index)=>{
            let msg = `xxxxxxxxxxxxxxxxxxxxxxxxx`.replace('x',index);
            if(index%2) msg += msg;
            msg = "消息" + msg;
            return {
              label:msg,
              id:index,
            }
          })
          resolve({
            code:200,
            message:"ok",
            datas:list,
          })
        },1000);
      })
    },
    // 获取全球比价tabs列表
    getPriceComparisonTabList(){
      let url = "/api/topQuotation/listTopQuotation";
      let data = {};
      this.priceComparisonTabsLoading = true;
      this.axios.get(url,{params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.priceComparisonTabsLoading = false;
          let list = res.datas ||[];
          this.globalPriceComparisonTabs = list;
        })
        .catch(res=>{
          this.priceComparisonTabsLoading = false;
          this.globalPriceComparisonTabs = [];
        })
    },
    /**
     * 点击某条比价线路tabItem
     * @param item
     * @param index
     */
    clickPriceComparisonTabItem(item,index){
      this.visiblePriceComparison = true;
      this.currentPriceComparisonTabItem = Object.assign({},item);
      this.getPriceComparisonLineList(item.id);
    },
    /**
     * 获取某条比价线路tabItem下的详情（线路列表）
     * @param id
     * @return {boolean}
     */
    getPriceComparisonLineList(id){
      if(!id) {
        // return Promise.reject(new Error("缺少id"));
        return false;
      }
      let url = "/api/topQuotation/pageTopQuotationDetail";
      let data = {
        "pageNum": 1,
        "pageSize": 9999,
        "topQuotationId": id,
      };
      this.priceComparisonListLoading = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.priceComparisonListLoading = false;
          let data = res.data || {};
          let list = data.list ||[];
          this.priceComparisonList = list;
          this.compareBaseInfo.toCountryName = list[0].toCountryName
          this.compareBaseInfo.cityName = list[0].cityName
          this.compareBaseInfo.transportSchemeName = list[0].transportSchemeName
          this.compareBaseInfo.toCitiNames = list[0].toCitiNamesCode
        })
        .catch(res=>{
          this.priceComparisonListLoading = false;
          this.priceComparisonList = [];
        })
    },
    /**
     * 比价详情 查看方案详情
     * @param item
     */
    lookPriceComparisonPlanDetails(item){
      // sendCustomerOperationRecord("查看详情",`产品名称:${item.productName}`, { productId: item.productId })
      let params = {
        // 是否收藏标识
        concernSign: item.concernSign,
        // 国家id
        countryId: item.podlandId,
        // 供应商Id
        carrierId: item.carrierId,
        // 产品报价id
        productPriceHeaderId: item.productPriceHeaderId,
        // 计费单位
        chargeType: item.chargeType,
        // 起运城市id
        polCityId: item.fromCityId,
      };
      this.showText(params,true,!!item.isAllowCreateOrder ? 1 : 0);
    },
    /**
     * 比价详情 下单
     * @param options
     */
    priceComparisonPlaceOrder(options){
      if (!this.sessionGetUserInfo().token) {
        this.$root.Bus.$emit("showDialog", 0, true);
      } else {
        let item = Object.assign({},options,{
          //
          selfDelivery:"",
          // 派送方式
          deliveryType: options.deliveryType,
          // 运输方式code
          transportTypeCode: options.transportTypeCode,
          // 产品报价id (item.priceHeaderId)
          productPriceHeaderId: options.productPriceHeaderId,
          // 产品名称
          productName: options.productName,
          // 物流产品ID
          productId: options.logisticsProductId,
          // 供应商Id
          carrierId: options.carrierId,
          // 起运城市名称 (fromCityInfo.namec)
          cityName: options.cityName,
          // 起运城市id (fromCityInfo.id)
          fromCityId: options.fromCityId,
          // 起运城市
          cityList:[{
            // 起运城市id
            id: options.fromCityId,
            // 起运城市名称
            cityName:  options.cityName,
          }],
          // 起运城市信息
          toWarehouseInfo:null,
          // 目的国id
          countryId: options.podlandId,
          // 目的国id
          toCountryid: options.podlandId,
          // 目的国名称
          toCountryName: options.toCountryName,
          // 目的国名称
          countryNamec: options.toCountryName,
          // 海外仓库地址 (item.overseasWarehouseAddress)
          selfAddress: options.selfAddress,
          overseasWarehouseAddress: options.selfAddress,
          // 海外仓联系人 (item.overseasWarehouseContactPerson)
          selfContacts: options.selfContacts,
          overseasWarehouseContactPerson: options.selfContacts,
          // 海外仓库联络电话 (item.overseasWarehouseContactPhone)
          selfTelephone: options.selfTelephone,
          overseasWarehouseContactPhone: options.selfTelephone,
          // 可接货物类型 例："带电/带磁/普货"
          goodsTypeNames: options.goodsTypeNames,
          // 报价类型代码，FBA: EC; 私人地址：NON；FBA和私人地址：EC&NON
          priceCode: options.priceCode,
          // 送货到仓 仓库地址
          warehouseAddress: options.warehouseAddress,
          // 送货到仓 仓库联系人
          warehouseContactPerson: options.warehouseContactPerson,
          // 送货到仓 仓库联系方式
          warehouseContactTel: options.warehouseContactTel,
        });
        // sendCustomerOperationRecord("立即下单(热门线路)",`${item.productName}`, { productId: item.productId });
        this.checkCanPlaceOrder()
          .then(res=>{
            //去下单
            let tuoCheDataChecked = false;
            if (item.toWarehouseInfo) {
              sessionStorage.setItem("toFABck", JSON.stringify(item.toWarehouseInfo));
            }
            sessionStorage.setItem("goodsTypeName", JSON.stringify(item.goodsTypeNames));
            sessionStorage.setItem("itemWrap", JSON.stringify(item));
            sessionStorage.setItem("fromCityid", item.fromCityId);
            if (item.transportTypeCode) sessionStorage.setItem("transportTypeCode", item.transportTypeCode);
            sessionStorage.removeItem("countLIst_T");
            sessionStorage.setItem("isPrivate", JSON.stringify(false));

            const routerUrl = this.$router.resolve({
              path: "/takeOrder",
              query: {
                THFtype: tuoCheDataChecked,
                transportTypeCode: item.transportTypeCode,
                productPriceHeaderId: item.productPriceHeaderId,
                supplierId: item.carrierId ? item.carrierId : '',
                toCountryid: options.podlandId,
                toCityId: '',
                itemWrap: item,
                postcode: ''
              },
            });
            window.open(routerUrl.href, '_blank')
          })
      }
    },
    /**
     * 校验是否可以下单(验证当前客户登录信息是否可用)
     * @return {Promise<AxiosResponse<unknown>>}
     */
    checkCanPlaceOrder(){
      let customerId = this.sessionGetUserInfo().customerid;
      let url = `/corporation/checkCustomerIsAvailable/${customerId}`;
      return this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .catch(res=>{
          let msg = "该账号暂未通过审核，请联系客服人员";
          this.$message({
            message: "该账号暂未通过审核，请联系客服人员",
            type: "warning",
            offset: "500",
          });
          return Promise.reject(new Error(msg));
        })
    },
    /**
     * 查看 专线报价一览表
     */
    showPrivateLinesQuotation(){
      this.visiblePrivateLinesQuotation = true;
      if(this.startData.length <= 0 && !this.startDataLoading){
        this.getFBAStartPlace();
      }
    },
    /**
     * 收起 专线报价一览表
     */
    hidePrivateLinesQuotation(){
      this.visiblePrivateLinesQuotation = false;
    },
    /**
     * 获取专线报价数量
     * @return {Promise<AxiosResponse<unknown>>}
     */
    getPrivateQuotationNumber(){
      let url = `/api/FBAfee/queryQuotedSum`;
      // Promise.resolve({
      //   data:{
      //     code:200,
      //     data: Math.ceil(Math.random() * 100)
      //   }
      // })
      return this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.privateQuotationNumber = res.data || 0;
        })
        .catch(res=>{
          this.privateQuotationNumber = 0;
        })
    },
    applyShareWarehouse() {
      this.$router.push({ name: 'platformSharedWarehouse' })
    },
    getPriceList() {
      const data = {
        // 发货城市id
        pollandId: '',
        // 目的仓库(目的地id)
        podlandId: '',
        goodstypeId: '',
        transportCodes: '',
        toCountryId: '',
      }
    },
    productTabChange(code) {
      this.productTabCurrent = code
    },
    gotoJinrong () {
      sendCustomerOperationRecord("供应链金融");
      this.$router.push({ name: "supplyChainFinanceApply" })
      this.$store.commit("changeSetType", true)
      this.$store.commit("changeLogoshow", false) //关闭logo
    }
  },

  created () {
    this.$root.Bus.$on("getIndexstyle", (value) => {
      this.gethotstyle()
    })
    this.$root.Bus.$on("getIndexcity", (value) => {
      this.gethotcity()
    })
  },
  mounted () {
    console.log("999", this.$store.state.setType)
    this.$store.commit("changeactive", 1)
    this.$store.commit("changeSetType", true)
    document.addEventListener("click", (e) => {
      let thisClassName = e.target.className
      if (thisClassName !== "transition-box") {
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.isShow = false
      }
    })
    var that = this
    Utils.$on("changeNav", function (num) {
      // location.reload()
      // console.log("page reload")
      that.showType(num)
    })
    this.getBanner()

    this.getAllTransportTypes()
    // this.getFBAStartPlace()
    this.getPrivateQuotationNumber();
    this.getFBAtoCk()
    this.getWarehouse()
    this.gethotstyle()
    this.gethotcity()
    this.getTopMessageList()
    // this.getHotRecommendList();
    // this.findAllCountryExcludeCN()
    // this.$refs.appli.start();
    // this.getCitydata()
    if(this.$store.getters.token){
      console.log("首页 mounted","准备获取优惠券");
      if(this.$refs.getCoupon && this.$refs.getCoupon.getCouponList) this.$refs.getCoupon.getCouponList();
    }
  },
  destroyed () { },
  beforeDestroy() {
    console.log("首页 beforeDestroy");
    if(this.$refs.getCoupon && this.$refs.getCoupon.hideCouponList) this.$refs.getCoupon.hideCouponList();
  },
};
</script>

<style lang="scss" scoped>
.home-transport-tabs {
  z-index: 1;
}
.join-group-form-box{
  position: relative;
  z-index: 1;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 6px 10px 0 rgba(0,0,0,0.1);
  margin-top: 0;
  //margin-bottom:59px;
  margin-bottom: 0;
  background-color: white;
  padding: 20px 15px 20px 15px !important;
  min-height: 130px;
}
.join-group--radio{}
.join-group--radio-item{
  /deep/ .el-radio__input{
    line-height: 24px;
    .el-radio__inner{
      box-sizing: border-box;
      width: 18px;
      height: 18px;
      border-width: 1px;
      background-color: white;
      &:after{
        width: 10px;
        height: 10px;
      }
    }
    .el-radio__original{
      width: 100%;
      height: 100%;
    }
    &.is-checked{
      .el-radio__inner{
        &:after{
          width: 8px;
          height: 8px;
          background-color: #FF4D01;
        }
      }
    }
  }
  /deep/ .el-radio__label{
    line-height: 24px;
    font-size: 16px;
    font-family: PingFang SC;
  }
  &.is-checked{
    /deep/ .el-radio__label{
      font-weight: 500;
    }
  }
}

.home-price-comparison{
  margin-top: 30px;
  //margin-bottom: 40px;
  //height: 80px;
  //background-color: #eee;
  position: relative;
  z-index: 1;
}
</style>

<style lang="scss" scoped>
.Hotpopular {
  background: url('../../assets/indexImg/Hotpopular.png') no-repeat;
  height: 468px;
  background-size: 100% 100%;
}
.Hotcounter {
  width: 25%;
  box-sizing: border-box;
  float: left;
  // padding: 0 10px;
  height: 140px;
  // margin-bottom: 18px;
  position: relative;
  border-radius: 30px;
}
.hot-join-group__list {
  width: 100%;
  max-width: 1200px;
  overflow: hidden;
}
.Hotcounter >>> .el-card__body {
  padding: 20px;
}
.Hot_wrap_x >>> .el-card__body {
  // padding: 24px 20px;
  &:after {
    content: "";
    display: block;
    clear: both
  }
}
.left {
  width: 100%;
}

.card_Hover {
  background-image: url(https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/home/hotline-bg.png);
  position: relative;
}
.card_Hover:hover .popularBtn {
  background: #FF4D01;
  border-radius: 25px;
  color: #ffffff;
}
.hot-line-label{
  position: absolute;
  top: 0;
  left: 0;
  padding: 3px 3px 0;
  &--item{
    min-width: 80px;
    max-width: 160px;
    padding: 0 10px;
    height: 25px;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #FF3228;
    text-align: center;
    color: white;
    font-size: 14px;
    border: 1px solid #FFFFFF;
    border-radius: 10px 0 20px 0;
  }
}
.popularBtn {
  box-sizing: border-box;
  width: 120px;
  height: 50px;
  background: #ffe3e6;
  border: 2px solid #FF4D01;
  border-radius: 25px;
  color: #FF4D01;
  cursor: pointer;
}

/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.showTop {
  width: 100%;
  transition: 0.3s;
  // margin-top: 260px;
  // margin-top: 340px;
  // margin-top: 660px;
}
.HotStyle {
  width: 1200px;
  margin: 0 auto;
  // border: 6px solid #FF4D01;
  box-sizing: border-box;
  border-radius: 30px;
  // position: relative;
  padding: 30px 0;
}
.hot_header_img {
  position: absolute;
  top: -150px;
  left: 50%;
  margin-left: -165px;
}
.Hotmemberzone {
  width: 100%;
  // float: left;
  margin: 0 auto;
  // margin-top: 31px;
  // background: #f5f5f5;
  position: relative;
  background: #FFFFFF;
  font-size: 0px;
  // padding-top: 68px;
  // z-index: 99;
}

.Hotwrap {
  width: 100%;
  // float: left;
  margin: 0 auto;
  margin-top: 31px;
  // background: #f5f5f5;
  position: relative;
  background: #FFFFFF
  // padding-top: 68px;
  // z-index: 99;
}

.video {
  position: absolute;
  right: 0;
  top: 82px;
  border-radius: 20px;
  overflow: hidden;
}

.hotlist {
  width: 100%;
  float: left;
}
.hotItem {
  width: 100%;
  height: 176px;
  box-sizing: border-box;
  float: left;
}
.hindDown {
  display: none;
}
.showDown {
  transition: 0.3s;
  transform: translate(0, -76px);
}
.wrap_s {
  float: left;
}
.Thicon {
  background: url('../../assets/thiconi.png') no-repeat;
  background-size: 100% 100%;
  width: 15px;
  height: 15px;
  text-align: center;
  color: #c6c6c6;
  font-weight: bold;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.Zxicon {
  background: url('../../assets/zx.png') no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}

.Xqicon {
  background: url('../../assets/zx.png') no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}

.navItem {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  float: left;
  // margin-right: 52px;
  // margin-left: 20px;
  position: relative;
  cursor: pointer;
}
.activesonty {
  color: #FF4D01;
}
.Gotobtn {
  cursor: pointer;
  // margin-top: -10px;
  width: 170px;
  height: 50px;
  background: #FF4D01;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  color: #ffffff;
}
.checkbox {
  margin-top: 8px;
  width: 170px;
  height: 30px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}

.card_wrap {
  min-width: 1100px;
  width: 1100px;
  background: #ffffff;
  box-shadow: 0px 0px 39px 5px rgba(208, 208, 208, 0.32);
  border-radius: 10px;
  float: left;
  padding: 24px 35px 34px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.Bom_style {
  width: 95px;
  height: 30px;
  background: #f9c158;
  border-radius: 15px;
  float: left;
  margin-right: 30px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  border: 1px solid #fff !important;
}
.count_Bom {
  width: 100%;
  float: left;
  margin-top: 16px;
  min-height: 30px;
}
.showbgColor {
  background: #ffffff;
}
.show_count {
  transform: translate(0, 0);
  margin: 0 auto;
  box-sizing: border-box;
  // position: relative;
}
.huowuData {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: column;
  padding: 0px 0 100px 0;
}
.select {
  position: relative;
}
.count_text >>> .el-input__inner {
  padding: 12px 20px 20px;
  border: none !important;
  border-radius: 100px !important;
  background: #F8F8F8!important;
  height: 50px;
  // text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  // height: 140px;
}
.el-col {
  border-radius: 4px;
}
.count_text {
  // margin-top: 20px;
  padding: 29px 26px 0 22px;
  box-sizing: border-box;
  width: 1200px;
  // max-width: 1200px;
  background: #ffffff;
  border-radius: 10px 10px 30px 30px;
  border-radius: 0 0 30px 30px;
  // box-shadow: 0px 0px 62px 0px rgba(35, 35, 35, 0.11);
  box-shadow: 0 10px 10px 0px rgba(35, 35, 35, 0.06);
}
.nav_count {
  width: 100%;
  /* height: 80px; */
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  // bottom: calc((-0.7 * 20vw * 0.5) + 18%);
  bottom: -60px;
}
.LR_center {
 /*  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center; */
  height: 65px;
  background: url(https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/home/hotline-button.png);
  background-size: auto 100%;
  background-position: center;
}

.index_wrap {
  // background: url("../../assets/indexbg2.png") no-repeat;
  min-height: 300px;
  background: linear-gradient(180deg, #efefef, transparent);
  background-size: auto 100%;
  background-position: center;
  // height: 728px;
  position: absolute;
  .home-banner-slide__image {
    margin: 0 auto;
    object-fit:cover;
    height: 100%;
  }
  .banner-item {
    height: 100%;
    &:hover {
      cursor: pointer;
    }
  }
}
.notBg {
  background: #ffffff;
  background-size: cover;
}
.drawer >>> .el-drawer__body {
  overflow: auto !important;
}
.transition-box {
  background: #ffffff;
  border-radius: 4px;
  text-align: left;
  padding: 20px 20px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  background-color: #fff;
  box-shadow: 0px 6px 21px 0px rgba(181, 181, 181, 0.5);
}
// .divider >>> .el-divider--vertical {
//   height: 2em;
// }
.el-divider--vertical {
  margin: 0 16px;
}
.selectWrap {
  position: relative;
}
.selectWrap >>> .el-input__inner {
  text-align: left;
}

.selectWrap1,
.selectWrap2,
.selectWrap3 {
  position: relative;
}
.selectWrap1 >>> .el-input__inner {
  text-align: left;
}

.selectWrap2 >>> .el-input__inner {
  text-align: left;
}
.selectWrap3 >>> .el-input__inner {
  text-align: left;
}

.transition_son {
  position: absolute;
  bottom: -142px;
  left: 0;

  // box-shadow: 0px 2px 12px 0px rgba(0 0 0 / 10%);
  height: 136px;
}
.cityBtn {
  padding: 9px 9px;
  color: #666;
  cursor: pointer;
  float: left;
}
.cityBtn:hover {
  color: #FF4D01;
}

.step-info {
  min-width: 1100px;
  width: 1100px;
}
</style>

<style scoped>
.one-1 {
  display: flex;
  border-bottom: 1px solid #eee;
}

li.shops-li {
  display: flex;
}

.two-left {
  width: 50px;
  /* margin-right: 10px; */
  font-weight: bold;
}

.two-right {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  width: 460px;
}

/* .two-all {
  padding: 0 6px;
  background: #f5f5f5;
  margin-right: 10px;
  margin-bottom: 6px;
  border-radius: 20px;
  color: #666;
  cursor: pointer;
  min-width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */
.two-all {
  width: 60px;
  padding: 6px 10px;
  background: #f5f5f5;
  margin-right: 10px;
  margin-bottom: 6px;
  border-radius: 20px;
  color: #666;
  cursor: pointer;
  min-width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.two-all:hover {
  background: #FF4D01;
  color: white;
  cursor: pointer;
}
.twoShow {
  background: #FF4D01;
  color: white;
  cursor: pointer;
}
ul.left-all {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.right {
  width: 100%;
  height: 200px;
  overflow: auto;
  padding-top: 20px;
}
.left-tips {
  padding: 0 3px;
  text-align: center;
  padding-bottom: 15px;
  cursor: pointer;
}

.right::-webkit-scrollbar {
  display: none;
}
/* .shops-li.right-item-hook {
    margin-top: 10px;
    padding-top: 5px;
} */
.left-address {
  margin-top: -1px;
  margin-left: 5px;
  cursor: pointer;
  width: 60px;
  padding-bottom: 20px;
}

.selectWrap3 >>> .el-tabs__item {
  padding: 0 4px;
}

.SlowAlterBac {
  transform: translateZ(0);
  position: relative;
  transition-property: color;
  transition-duration: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-box {
  padding: 70px 20px;
  position: relative;
}

.emptyClass {
  display: flex;
  justify-content: center;
  /* align-items: center; */
}

.empty-text {
  position: absolute;
  bottom: 20px;
}

.self_support {
  width: 50px;
  height: 26px;
  background-color: #FF4D01;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  color: #fff;
  margin-left: 10px;
}
</style>
<style scoped lang="scss">
/* 公司介绍 + 视频 start*/
.home-video {
  &__warp {
    clear: both;
    width: 100%;
    position: relative;
    z-index: 1;
    // background-color: #fff8f9;
    margin-bottom: 30px;
    &:before {
      position: absolute;
      z-index: 1;
      content: '';
      background-color: white;
      top: 0;
      bottom: 0;
      right: 0;
      width: 50%;
      /*height: 100%;*/
    }
  }
  &__container {
    position: relative;
    z-index: 2;
    padding-top: 80px;
    padding-bottom: 70px;
    width: 80%;
    max-width: 1200px;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow: hidden;
  }
  &__left {
    flex: 1;
    min-width: 470px;
    box-sizing: border-box;
  }
  &__title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 33px;
  }
  &__description {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-indent: 32px;
  }
  &__go {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    width: 127px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    background: rgb(185, 57, 71);
  }
  &__right {
    flex: 2.7;
    min-width: 600px;
    /*width: 900px;*/
    /*height: 600px;*/
    video {
      width: 100%;
      height: auto;
    }
  }
}
@media (min-width: 1338px) {
  .home-video {
    &__left {
      padding-right: 110px;
    }
    &__go {
      margin-top: 60px;
    }
  }
}
@media (max-width: 1337px) {
  .home-video {
    &__left {
    }
    &__go {
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
}
.Header_line {
  display: inline-block;
  width: 133px;
  border-top: 2px solid #FF4D01;
  vertical-align: 10px;
}
/* 公司介绍 + 视频 end*/

/* 视频 start*/
.my-video {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  video {
    position: relative;
    z-index: 1;
  }
  .video-button {
    display: none;
  }
  &:hover .video-button {
    display: block;
  }
  .video-button {
    $button-size: 120px;
    $font-size: 90px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    margin-left: -$button-size/2;
    margin-top: -$button-size/2;
    width: $button-size;
    height: $button-size;
    line-height: $button-size + 6px;
    cursor: pointer;
    font-size: $font-size;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    text-align: center;
    color: #ccc;
    transition: 0.4s ease;
    &:hover {
      color: white;
    }
  }
}
/* 视频 end*/
</style>


<style lang="scss" scoped>
.header-select {
  margin-top: -50px;
  padding-top: 20px;
  width: 100%;
  width: 1200px;
  height: 64px;
  background: #fff;
  border-radius: 30px 30px 0 0;
  position: relative;
  z-index: 1;
  // background: green;
}
.navItem {
  width: 190px;
  max-width: 16%;
  height: 64px;
  // background: red;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgs {
  width: 31px;
  height: 31px;
  margin-right: 20px;
}
.imgs-1 {
  width: 28px;
  height: 31px;
  margin-right: 20px;
}
.activesonty {
  background: #ffffff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  z-index: 2000;
}
.activesonty5 {
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  // background: #ffffff;
  // opacity: 0.4;
  background: rgba(255, 255, 255, 0.4);
  z-index: 2000;
}
.count_text {
  border-top-left-radius: 0px;
}
.show-all {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.show-info {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  border-bottom: 4px solid #FF4D01;
}
.el-row >>> .transition-box {
  border-radius: 20px !important;
}
.Hot_wrap_x {
  width: 100%;
  margin-top: 30px;
}
.gif-pointer {
  width: 70px;
  height: 70px;
  position: absolute;
  bottom: -11px;
  right: 30px;
}

.count_text >>> i.el-select__caret.el-input__icon.el-icon-arrow-up {
  margin-right: 10px;
}

.home-video__go {
  width: 146px;
  height: 50px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 50px;
  background: #FF4D01;
  border-radius: 25px;
}
.label-1 {
  display: flex;
  align-items: center;
  span {
    font-size: 18px;
  }
}
.hot-line >>> #tab-first {
  height: 50px;
}

.hot-info {
  display: flex;
  justify-content: space-between;
}


.searchBtn {
  cursor: pointer;
  display: inline-block;
  min-width: 90px;
  height: 30px;
  background: #f5f5f5;
  border-radius: 15px;
  line-height: 30px;
  text-align: center;
  margin: 5px;
  overflow: hidden;
}
.searchBtn:hover {
  background: #FF4D01;
  color: #ffffff;
}
</style>

<style lang="scss" scoped>
.wrap_R >>> .el-icon-phone-outline {
  font-size: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}

.step5 >>> .el-button.el-button--primary.is-round {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
}
.icon_collect {
  width: 22px;
  height: 21px;
  display: inline-block;
  background: url('../../assets/icon_collect.png') no-repeat;
}
.icon_collect_pre {
  width: 22px;
  height: 21px;
  display: inline-block;
  background: url('../../assets/icon_collect_pre.png') no-repeat;
}

.current {
  font-size: 16px;
  border-bottom: 2px solid #FF4D01;
  color: #FF4D01;
}

.txt2 {
  background: #FF4D01;
  color: #ffffff;
}
.txt1 {
  color: #000;
}

.twoShow {
  background: #FF4D01;
  color: white;
  cursor: pointer;
  width: 60px;
  padding: 2px 5px;
  font-size: 14px;
}
</style>

<style lang="scss">
.txt-1 {
  background: #fff;
  border: 1px solid #fff !important;
}
.el-tooltip__popper.is-light[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: #fff !important;
}

.el-tooltip__popper.is-light[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: #fff;
}
.home-price-comparison-drawer{
  overflow: hidden;
  .el-drawer__body{
    overflow: hidden;
    box-sizing: border-box;
  }
}
.private-lines-quotation-drawer{
  .el-drawer__header{
    display: none;
  }
  .el-drawer__body{
  }
}
.quotation-drawer-box{
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  height: 100%;
  .quotation-drawer-header{
    margin-bottom: 6px;
  }
}
</style>

<style scoped lang="less">
// @import "~@assets/css/defined";
.search-bottom-box {
  margin-top: -220px;
  position: relative;
  padding-top: 230px;
  padding-bottom: 40px;
  // background: #fff;
  z-index: 0;
  // overflow: hidden;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
  .city-bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .Hotwrap {
    margin-top: 0;
    // position: relative;
  }
  // background: #fff;
}
.gif-pointer {
  width: 70px;
  height: 70px;
  position: absolute;
  // bottom: -11px;
  bottom: 10px;
  // right: 30px;
  right: 50px;
}
.Hotcounter {
    width: 25%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    float: left;
    height: 140px;
    position: relative;
}
.el-card {
  border: none;
  transition: ease 0.4s;
}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    border: none;
    -webkit-box-shadow: 0 2px 12px 0 rgba(254, 226, 228, .9);
    box-shadow: 0 2px 12px 0 rgba(254, 226, 228, .9);
    z-index: 1
}

.SlowAlterBac:active, .SlowAlterBac:focus, .SlowAlterBac:hover {
    color: #fff;
    // border: 1px solid rgba(254, 226, 228, 1);
    -webkit-box-shadow: 4px 4px 4px 0 rgba(254, 226, 228, 1);
    box-shadow: 4px 4px 4px 0 rgba(254, 226, 228, 1);
    z-index: 1
}

.SlowAlterBac:active:before, .SlowAlterBac:focus:before, .SlowAlterBac:hover:before {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
}
.inline-supplier{
  padding: 50px 0;
}
.tabs{
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  &-item + &-item{
    margin-left: 22px;
  }
  &-item{
    width: 70px;
    height: 34px;
    line-height: 34px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
    background: #FFFFFF;
    color: #666666;
    &.active{
      background-color: #FF4D01;
      color: white;
      cursor: initial;
    }
  }
}

.supplier-list-box{
  width: calc(100% - 52px);
  padding: 30px 26px;
  padding-bottom: 0;
  margin: 0 auto;
  background: #FFFFFF;
  box-shadow: 0px 3px 24px 0px rgba(0,0,0,0.02);
  border-radius: 20px;
}
.supplier-slide__item {
  // border: 1px solid #EEEEEE
  width: calc(100% - 2px);
}
.hint-row{
  min-height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slide-box{
  position: relative;
  overflow: visible;
}
/*左右箭头*/
.slide-arrow{
  display: none;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: .3s;
  transition: .3s;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  //top: 50%;
  top: 210px;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
  width: 45px;
  height: 45px;
  background-color: white;
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);
  &:hover{
    background-color: #eaf9f8;
    i{
      color: #FF4D01;
    }
  }
  i{
    cursor: pointer;
    color: #666;
    font-size: 24px;
    font-weight: bold;
  }

  //&--left {
  //  left: 16px;
  //}
  //&--right {
  //  right: 16px;
  //}
  @media screen and (min-width: (1200px + 76px * 2)){
    &{
      display: block;
    }
    &--left{
      left: -22px;
    }
    &--right{
      right: -22px;
    }
  }
}

.supplier-slide{
  width: 100%;
  &__item{
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-carousel__container {
    border: 1px solid #EEEEEE;
    z-index: 0;
  }

  /*指示器*/
  /deep/ .el-carousel__indicators{
    padding: 30px - 12px 0;
  }
  /deep/ .el-carousel__indicator{

    .el-carousel__button{
      background: #DADADA;
      width: 50px;
      height: 4px;
      // border-radius: 2px;
      opacity: 1;
      &:hover{
        background-color: #999;
      }
    }
    &.is-active{
      .el-carousel__button{
        background: #FF4D01 !important;
      }
    }
  }
}
.supplier-item{
  width: 224px;
  height: 175px;
  background: #FFFFFF;
  border-radius: 20px;
  margin-right: 20px;
  cursor: pointer;
  &:nth-child(4){
    margin-right: 19px;
  }
  &:nth-child(5n){
    margin-right: 0;
  }
  &:nth-child(5) ~ &{
    margin-top: 20px;
  }
  &__image{
    display: block;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    object-fit: contain;
  }
  &__name{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}

.button-join{
  display: block;
  margin: 0 auto;
  width: 240px;
  height: 50px;
  border-radius: 10px;
  font-size: 18px;
}
.trigger-button {
  position: absolute;
  width: 250px;
  height: 60px;
  right: 75px;
  bottom: 70px;
  border-radius: 50%;
  cursor: pointer;
}
.hot-join-group{
  padding: 24px 0 50px;
  &__header{
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .title{
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 36px;
    }
    .next{
      display: flex;
      align-items: center;
      text-decoration: none;
      span{
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        line-height: 36px;
      }
      .icon{
        margin-left: 8px;
        display: block;
        width: 16px;
        height: 16px;
      }
    }
  }
  &__list{
    display: flex;
  }
  &__item{
    //margin-bottom: 24px;
    &:nth-child(1),
    &:nth-child(2){
      margin-right: 20px;
    }
  }
}

/*滚动消息*/
.join-scroll-message{
  box-sizing: border-box;
  height: 60px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 15px 24px;
  //margin-bottom: 50px;
  box-shadow: 0px 3px 24px 0px rgba(0,0,0,0.05);
  margin-top: 24px;
  /deep/ .scroll-message__icon{
    height: 26px;
  }
}
/* 热门国家 */
.hot-country-list-box{
  width: 100%;
  padding: 30px 0 0;
  margin: 0 auto;
  background: #FFFFFF;
  // box-shadow: 0 3px 24px 0 rgba(0,0,0,0.02);
  // border-radius: 20px;
}
.hot-country-tabs{
  /deep/ .el-tabs__header{
    // padding: 0 30px;
    margin-bottom: 0;
    .el-tabs__nav-wrap{
      &:after{
        display: none;
      }
    }
    .el-tabs__item{
      font-size: 24px;
      &:not(.is-active){
        color: #999;
      }
      &.is-active{
        font-weight: bold;
      }
    }
  }
}
.hot-country-hit{
  padding: 10px 20px;
  background-color: rgba(237,126,46,0.12);
  border-radius: 5px;
  line-height: 28px;
  font-size: 18px;
  font-weight: 400;
  color: #FF9643;
}

/* 覆盖国家右侧 立即查看 （查看 专线报价一览表） */
.look-private-line-quotation{
  width: 254px;
  height: 30px;
  border-radius: 10px;
  background: #FFF6F2;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  //padding-right: 2px;
  .look-label{
    width: 141px;
    margin: 0 6px 0 10px;
    text-align: center;
    font-size: 16px;
    color: #141414;
  }
  .look-btn{
    box-sizing: border-box;
    height: 26px;
    line-height: 26px;
    width: 95px;
    background: #FF4D01;
    text-align: center;
    font-size: 14px;
    border-radius: 13px;
    color: white;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      background-color: #f86f1f;
    }
    &:active{
      //filter: grayscale(10%);
      background-color: #ee732f;
    }
  }
}
/**
 * 首页公共内容box和标题
 */
.home-common-box{
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.home-common-title{
  text-align: center;
  margin-bottom: 50px;
  img{
    max-width: 100%;
    height: auto;
    display: inline-block;
    border: none;
  }
}

/**
 * 热门推荐
 */
.hot-recommend{
  padding: 30px 0;
  /deep/ .el-tabs__header{
    padding: 0 0;
    margin-bottom: 30px;
    .el-tabs__nav-wrap{
      &:after{
        display: none;
      }
    }
    .el-tabs__item{
      font-size: 18px;
      &:not(.is-active){
        color: #999;
      }
      &.is-active{
        font-weight: bold;
      }
    }
  }
}
.hot-line-item{
  /deep/ .price-blurring--box{
    .price-blurring--currency{
      //font-size: 16px;
    }
    .price-blurring--price{
      font-size: 30px;
    }
    .price-blurring--unit{
      //font-size: 16px
    }
  }
}
.el-link /deep/ a {
  text-decoration: none;
}

/deep/ .el-carousel__indicators--horizontal {
  bottom: 120px;
  .el-carousel__indicator--horizontal {
    padding: 12px 10px;
  }
}
@ossPath: "https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0";
.air-bg {
  width: 161px;
  height: 105px;
  background: url("@{ossPath}/pages/home/hotLine/air.png");
}
.pickup-bg {
  width: 128px;
  height: 108px;
  background: url("@{ossPath}/pages/home/hotLine/pickup.png");
}
.ship-bg {
  width: 140px;
  height: 104px;
  background: url("@{ossPath}/pages/home/hotLine/ship.png");
}
.cloud_warehouse {
  width: 100%;
  padding-bottom: 54px;
  min-height: 750px;
  background: #ffe5cf url("@{ossPath}/pages/home/yun_warehouse/img_bg.png") no-repeat;
  .cloud-ware-tabs {
    margin: 20px auto;
    margin-bottom: 30px;
    width: 410px;
    display: flex;
    justify-content: center;
    &__item {
      width: 160px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #FFFFFF;
      font-size: 18px;
      font-weight: 600;
      color: #141414;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        color: #FFFFFF;
        background: rgb(255, 205, 179);
      }
      &.isActive {
        color: #FFFFFF;
        background: #FF4D01;
        // cursor: auto
      }
    }
  }
  .apply {
    margin-top: 16px;
    font-size: 30px;
    font-weight: 600;
    color: #141414;
    display: flex;
    &_btn {
      margin: 40px auto 0;
      width: 380px;
      height: 70px;
      background: #FF4D01;
      border-radius: 35px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .advantage {
    height: 70px;
    margin-top: 15px;
    padding-left: 27px;
    background: #FFFFFF;
    border-radius: 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #141414;
    background-size: 100% 100%;
  }
  .line {
    width: 1200px;
    background: transparent;
    margin-top: 10px;
  }
}
.query-change-wrap {
  position: relative;
  display: flex;
  z-index: 99;
  .query-item {
    margin-right: 10px;
    width: 200px;
    height: 65px;
    line-height: 55px;
    text-align: center;
    font-size: 20px;
    color: #141414;
    background: rgba(255, 255, 255, .7);
    border-radius: 16px 16px 0px 0px;
    cursor: pointer;
    transition: all .3s;
    &.isCurrent {
      font-weight: 500;
      background: #FFFFFF;
    }
  }
}
.inquiry-tab {
  margin-top: -10px;
  background: #FFFFFF;
  border-radius: 16px 16px 0 0;
  li {
    display: inline-block;
    padding: 0 8px;
    margin: 0 35px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    color: #141414;
    font-size: 16px;
    border-bottom: 4px solid transparent;
    cursor: pointer;
    transition: all .2s;
    &.isactive {
      font-size: 18px;
      font-weight: bold;
      color: #FF4D01;
      border-bottom: 4px solid #FF4D01
    }
  }
}
</style>
<style>
.el-tooltip__popper.is-dark.head-propper-tips {
  background: rgba(0,0,0,0.6)!important;
  border-radius: 5px;
}
.el-tooltip__popper.is-dark.head-propper-tips .popper__arrow {
 border-bottom-color: rgba(0,0,0,0.3)!important;
}
.clickable-area {
  position: absolute;
  /* bottom: 125px;
  left: 267px; */
  bottom: calc(22%);
  left: calc(18%);
  width: 241px;
  height: 80px;
  z-index: 1;
  cursor: pointer;
}
.clickable-area2 {
  position: absolute;
  bottom: 11%;
  left: 37%;
  width: 405px;
  height: 73px;
  z-index: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeIndex.vue